const workspaceStyles = `
@import url('https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;0,6..72,600;0,6..72,700;1,6..72,400&family=Inter:wght@400;450;500;600;700&family=Roboto+Mono:wght@400;500&display=swap');

.ai-ws {
  --ws-bg: #ffffff;
  --pr-surface: #ffffff;
  --pr-ink: #2f3947;
  --pr-ink-3: #6b7c93;
  --pr-ink-4: #6b7c93;
  --pr-ink-5: #9baabe;
  --pr-accent-ink: #3e4957;
  --pr-accent-soft: rgba(29,61,72,0.06);
  --pr-accent-soft-2: rgba(29,61,72,0.12);
  --pr-r-sm: 6px;
  --ws-panel: #FFFFFF;
  --ws-soft: #edf1f5;
  --ws-hover: #e9eef3;
  --ws-sidebar: #edf1f5;
  --ws-ink: #2f3947;
  --ws-ink-2: #3e4957;
  --ws-ink-3: #4b5562;
  --ws-ink-4: #6b7c93;
  --ws-ink-5: #9baabe;
  --ws-line: #e4eaf0;
  --ws-line-2: #d3dae4;
  --ws-accent: #1d3d48;

  --ws-a-alex: #C47A4A;
  --ws-a-prospecting: #5F7F6A;
  --ws-a-forecasting: #4A6B85;
  --ws-a-postmeeting: #8B5A8F;
  --ws-a-human: #B8935A;

  --ws-ok: #2F7A4E;
  --ws-warn: #B8702A;
  --ws-err: #B84A3E;
  --ws-info: #3B6BA8;

  --ws-serif: 'Newsreader', 'Iowan Old Style', Georgia, serif;
  --ws-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --ws-mono: 'Roboto Mono', ui-monospace, Menlo, monospace;

  --ws-r-sm: 6px;
  --ws-r-md: 10px;
  --ws-r-lg: 14px;

  --ws-shadow-sm: 0 1px 2px rgba(15,30,45,0.04);
  --ws-shadow-md: 0 4px 16px rgba(15,30,45,0.06), 0 1px 2px rgba(15,30,45,0.04);
  --ws-shadow-lg: 0 24px 48px -12px rgba(15,30,45,0.14), 0 2px 6px rgba(15,30,45,0.04);

  display: grid;
  grid-template-columns: 248px 1fr;
  height: 100%;
  width: 100%;
  background: var(--ws-bg);
  color: var(--ws-ink-3);
  font-family: var(--ws-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  isolation: isolate;
}

/* ===== Sidebar ===== */
.ws-sidebar {
  background: var(--ws-sidebar);
  border-right: 1px solid var(--ws-line);
  display: flex;
  flex-direction: column;
  padding: 14px 10px 10px;
  overflow: hidden;
  min-height: 0;
}
.ws-sb-scrollable {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.ws-sb-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px 14px;
  border-bottom: 1px solid var(--ws-line);
  margin-bottom: 10px;
}
.ws-sb-brand-mark {
  width: 28px; height: 28px;
  border-radius: 7px;
  background: linear-gradient(145deg, #182b35, #1d3d48);
  color: #e8f9f8;
  display: grid; place-items: center;
  font-family: var(--ws-serif);
  font-size: 16px;
  font-weight: 600;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
  flex-shrink: 0;
  overflow: hidden;
}
.ws-sb-brand-mark img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ws-sb-brand-mark:has(img) { background: transparent; }
.ws-sb-brand-name {
  font-family: var(--ws-serif);
  font-size: 17px;
  letter-spacing: -0.01em;
  color: var(--ws-ink);
  line-height: 1.1;
}
.ws-sb-brand-sub {
  font-size: 11px;
  color: var(--ws-ink-4);
  letter-spacing: 0.02em;
}
.ws-sb-newchat {
  border: 0; background: transparent; padding: 4px;
  border-radius: 6px; color: var(--ws-ink-3);
  cursor: pointer; display: grid; place-items: center;
}
.ws-sb-newchat:hover { background: rgba(0,0,0,0.06); color: var(--ws-ink); }

.ws-sb-search {
  display: flex; align-items: center; gap: 8px;
  background: rgba(0,0,0,0.02);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 7px 10px;
  margin-bottom: 14px;
  color: var(--ws-ink-4);
  font-size: 13px;
}
.ws-sb-search input {
  border: 0; background: transparent; outline: none;
  flex: 1; color: var(--ws-ink); font-size: 13px;
  min-width: 0; font-family: var(--ws-sans);
}

.ws-sb-section-label {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--ws-ink-4);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 8px 10px 6px;
}
.ws-sb-nav {
  display: flex; flex-direction: column;
  gap: 1px;
}
.ws-sb-item {
  position: relative;
  display: flex; align-items: center; gap: 10px;
  padding: 7px 10px;
  border-radius: 7px;
  color: var(--ws-ink-2);
  font-size: 13.5px;
  font-weight: 450;
  cursor: pointer;
  border: 0;
  background: transparent;
  text-align: left;
  width: 100%;
  transition: background 0.12s;
  font-family: var(--ws-sans);
}
.ws-sb-item:hover { background: rgba(0,0,0,0.035); }
.ws-sb-item.active {
  background: rgba(0,0,0,0.06);
  color: var(--ws-ink);
  font-weight: 600;
}
.ws-sb-item.active::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: #c3e8e8;
  border-radius: 0 2px 2px 0;
}
.ws-sb-item-footer {
  font-size: 12.5px;
  color: var(--ws-ink-4);
  padding: 5px 10px;
}
.ws-sb-item-footer:hover { color: var(--ws-ink-3); }
.ws-sb-item-footer.active { color: var(--ws-ink); }
.ws-sb-nav-bottom {
  margin-top: auto;
  padding-top: 8px;
}
.ws-sb-divider {
  height: 1px;
  background: var(--ws-line);
  margin: 6px 6px;
}

/* ===== History page ===== */
.ws-history {
  flex: 1;
  overflow: auto;
  /* Reserve the scrollbar gutter so content doesn't shift sideways when a
     scrollbar appears (e.g. after "Show more" in the Inbox). */
  scrollbar-gutter: stable;
}
.ws-history-inner {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 32px 48px;
}
.ws-history-title {
  font-family: var(--ws-sans);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0 0 16px;
  color: var(--ws-ink);
}
.ws-history-search {
  display: flex; align-items: center; gap: 8px;
  background: #ffffff;
  border: 0.5px solid var(--ws-line-2);
  border-radius: var(--ws-r-md);
  padding: 8px 12px;
  margin-bottom: 24px;
  color: var(--ws-ink-4);
}
.ws-history-search input {
  border: 0; background: transparent; outline: none;
  flex: 1; color: var(--ws-ink); font-size: 13px;
  font-family: var(--ws-sans);
}
.ws-history-empty {
  padding: 32px 0; text-align: center; color: var(--ws-ink-4); font-size: 13px;
}
.ws-history-group { margin-bottom: 18px; }
.ws-history-group-label {
  font-size: 10.5px; font-weight: 600;
  color: var(--ws-ink-4); letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0 4px 6px;
}
.ws-history-list { display: flex; flex-direction: column; gap: 1px; }
.ws-history-row {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 12px;
  border: 0; background: transparent;
  border-radius: 7px;
  font-family: var(--ws-sans); font-size: 13.5px;
  color: var(--ws-ink-2);
  cursor: pointer; text-align: left;
  transition: background 0.12s;
}
.ws-history-row:hover { background: rgba(0,0,0,0.035); }
.ws-history-row.active { background: rgba(0,0,0,0.06); color: var(--ws-ink); font-weight: 500; }
.ws-history-row-title { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ws-history-row-date { color: var(--ws-ink-5); font-size: 11.5px; flex-shrink: 0; }
/* WEB-6799: Inbox feed — compact rows grouped into Needs you / Unread / Earlier. */
.ws-inbox-section { margin-bottom: 22px; }
/* Extra breathing room before "Earlier" so it reads as a separate, lower-priority zone. */
.ws-inbox-section--spaced { margin-top: 40px; }
.ws-inbox-showmore {
  margin: 8px 0 0 8px;
  background: none; border: none; cursor: pointer; padding: 6px 2px;
  color: var(--ws-accent); font-size: 12.5px; font-weight: 500;
}
.ws-inbox-showmore:hover { text-decoration: underline; }
.ws-inbox-section-count {
  margin-left: 8px;
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 17px; height: 17px; padding: 0 5px;
  border-radius: 9px;
  background: var(--ws-line);
  color: var(--ws-ink-4);
  font-size: 11px; font-weight: 600; letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  vertical-align: middle;
}
.ws-inbox-list { display: flex; flex-direction: column; }
.ws-inbox-item { border-bottom: 1px solid var(--ws-line); border-radius: 8px; }
.ws-inbox-item.active { background: rgba(0,0,0,0.05); }
.ws-inbox-item--earlier { opacity: 0.6; }
.ws-inbox-item--earlier:hover { opacity: 1; }
/* Clicking the row toggles the inline preview; the header link opens the thread. */
.ws-inbox-row {
  display: flex; align-items: flex-start; gap: 14px;
  width: 100%;
  padding: 14px 8px;
  cursor: pointer; text-align: left;
  border-radius: 8px;
}
.ws-inbox-row:hover { background: rgba(0,0,0,0.025); }
.ws-inbox-row:focus-visible { outline: 2px solid var(--ws-accent); outline-offset: -2px; }
/* Icon + label link to the conversation, pinned to the right of the title line. */
.ws-inbox-link {
  margin-left: auto; flex-shrink: 0;
  display: inline-flex; align-items: center; gap: 5px;
  color: var(--ws-accent);
  font-size: 12.5px; font-weight: 500;
  text-decoration: none; white-space: nowrap;
}
.ws-inbox-link:hover { text-decoration: underline; text-underline-offset: 2px; }
.ws-inbox-icon {
  flex-shrink: 0;
  width: 34px; height: 34px;
  border-radius: 9px;
  display: grid; place-items: center;
}
.ws-inbox-icon--proposal { background: #fbedd3; color: #b9821f; }
.ws-inbox-icon--routine { background: #ece9fb; color: #6b5bd1; }
.ws-inbox-icon--message { background: #e3edfb; color: #3f6fbf; }
.ws-inbox-row-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.ws-inbox-row-head { display: flex; align-items: center; gap: 9px; min-width: 0; }
.ws-inbox-row-title {
  font-size: 15px; font-weight: 600; color: var(--ws-ink);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  min-width: 0; max-width: 100%;
}
.ws-inbox-tag {
  flex-shrink: 0;
  font-size: 11px; font-weight: 600;
  padding: 1px 7px; border-radius: 5px;
  white-space: nowrap;
}
.ws-inbox-tag--proposal { background: #fbedd3; color: #b9821f; }
.ws-inbox-row-preview {
  font-size: 13.5px; color: var(--ws-ink-4); line-height: 1.45;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  max-width: 100%;
}
.ws-inbox-meta {
  flex-shrink: 0; display: flex; align-items: center; gap: 8px;
  padding-top: 3px;
}
.ws-inbox-dot-slot { width: 7px; flex-shrink: 0; display: flex; justify-content: center; }
.ws-inbox-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ws-accent); }
.ws-inbox-when {
  width: 42px; flex-shrink: 0; text-align: right;
  font-size: 12.5px; color: var(--ws-ink-5); font-variant-numeric: tabular-nums;
}
.ws-inbox-chev-slot { width: 14px; flex-shrink: 0; display: flex; justify-content: center; }
/* Expanded message body — aligns under the title (icon 34 + gap 14 + pad 8). */
.ws-inbox-item-body { padding: 0 12px 14px 56px; }
/* Scroll container only — text styling comes from pr-prose so it matches chat. */
.ws-inbox-message { max-height: 360px; overflow-y: auto; padding-bottom: 8px; }
.ws-sb-item .ws-ic { width: 16px; height: 16px; flex-shrink: 0; color: currentColor; opacity: 0.85; }
.ws-sb-item .ws-count {
  margin-left: auto;
  font-size: 11px;
  background: var(--ws-ink);
  color: #e8f9f8;
  min-width: 18px; height: 18px;
  border-radius: 9px;
  display: grid; place-items: center;
  padding: 0 6px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.ws-sb-item .ws-count.muted {
  background: transparent;
  color: var(--ws-ink-4);
  font-weight: 500;
}
.ws-sb-item .ws-title-text {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  flex: 1; min-width: 0;
}

.ws-agent-swatch {
  width: 16px; height: 16px;
  border-radius: 5px;
  display: grid; place-items: center;
  font-family: var(--ws-serif);
  font-size: 8px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
  overflow: hidden;
}
.ws-agent-swatch img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ws-agent-swatch:has(img) { background: transparent; }

.ws-pill-dark {
  margin-left: auto;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 999px;
  color: #e8f9f8;
  background: var(--ws-ink);
  font-weight: 600;
  letter-spacing: 0.02em;
}

.ws-sb-conversations {
  flex: 1 1 auto;
  min-height: 0;
}
.ws-sb-group { margin-top: 2px; }
.ws-sb-group-head {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 10px;
  font-size: 11px; font-weight: 600;
  color: var(--ws-ink-4);
  letter-spacing: 0.04em;
  border: 0; background: transparent;
  cursor: pointer; width: 100%;
  text-align: left;
  font-family: var(--ws-sans);
}
.ws-sb-group-head:hover { color: var(--ws-ink-3); }
.ws-sb-group-count {
  margin-left: auto;
  font-size: 10px;
  color: var(--ws-ink-5);
  font-weight: 500;
}
.ws-sb-chev {
  display: inline-flex; align-items: center;
  transition: transform 0.12s;
  color: var(--ws-ink-5);
}
.ws-sb-chev.open { transform: rotate(90deg); }
.ws-sb-paused {
  margin-left: auto;
  font-size: 10px;
  color: var(--ws-ink-4);
  font-weight: 500;
  font-style: italic;
}

.ws-sb-unread-dot {
  position: absolute;
  left: 10px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #C62828;
}
.ws-sb-unread-dot-inline {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #C62828;
  flex-shrink: 0;
  margin-left: 4px;
}

.ws-sb-footer {
  flex-shrink: 0;
  padding-top: 10px;
  border-top: 1px solid var(--ws-line);
}
.ws-sb-footer-section {
  border-bottom: 1px solid var(--ws-line);
  padding-bottom: 4px;
  margin-bottom: 4px;
}
.ws-sb-footer-section > .ws-sb-item {
  position: relative;
  padding-left: 22px;
}

/* ===== Main pane ===== */
.ws-main {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--ws-bg);
}
.ws-back-btn {
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-family: var(--ws-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--ws-ink-3);
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}
.ws-back-btn:hover {
  color: var(--ws-ink);
  border-color: var(--ws-line-2);
}

.ws-main-inner {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 0;
}

.ws-topbar {
  display: flex; align-items: center;
  padding: 10px 32px;
  border-bottom: 1px solid var(--ws-line);
  background: var(--ws-bg);
  position: sticky; top: 0; z-index: 10;
}
.ws-topbar h1 {
  font-family: var(--ws-serif);
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.015em;
  margin: 0;
  color: var(--ws-ink);
}
/* Pairing dot: same colour on a background-run chip and its result chip,
   keyed off the shared child conversationId, so they read as one pair. */
.ws-pair-dot {
  width: 7px; height: 7px; border-radius: 50%;
  flex-shrink: 0; box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06) inset;
}
/* Right-aligned header actions (parent back-link + star). */
.ws-topbar-actions {
  margin-left: auto;
  display: flex; align-items: center; gap: 12px;
}
/* Back-link to the delegating (parent) conversation, shown in a child's full view. */
.ws-topbar-parent-link {
  display: inline-flex; align-items: center; gap: 5px;
  background: none; border: 0; padding: 0; margin: 0;
  font-family: var(--ws-sans); font-size: 12px; font-weight: 500;
  color: var(--ws-ink-4); cursor: pointer;
  transition: color 0.12s;
}
.ws-topbar-parent-link:hover { color: var(--ws-info); }
.ws-topbar .ws-crumb {
  font-family: var(--ws-serif);
  font-size: 28px;
  font-weight: 400;
  color: var(--ws-ink-4);
  cursor: pointer;
}
.ws-topbar .ws-crumb:hover { color: var(--ws-ink-3); }
.ws-topbar .ws-crumb-sep { color: var(--ws-ink-5); margin: 0 8px; }
.ws-topbar .ws-sub {
  font-size: 13px;
  color: var(--ws-ink-4);
  margin-top: 2px;
}
.ws-topbar-actions { margin-left: auto; display: flex; gap: 8px; align-items: center; }
.ws-topbar-star {
  background: none; border: none; cursor: pointer;
  color: var(--ws-ink-4);
  padding: 4px;
  border-radius: 4px;
  transition: color 0.15s;
}
.ws-topbar-star:hover { color: var(--ws-ink-2); }
.ws-topbar-starred { color: var(--ws-warn); }
.ws-topbar-starred:hover { color: var(--ws-warn); }

.ws-btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 7px 13px;
  border-radius: 999px;
  border: 1px solid var(--ws-line-2);
  background: white;
  color: var(--ws-ink-2);
  font-size: 13px;
  font-weight: 500;
  font-family: var(--ws-sans);
  transition: all 0.12s;
  cursor: pointer;
}
.ws-btn:hover { background: var(--ws-soft); }
.ws-btn-dark {
  background: var(--ws-ink);
  color: #e8f9f8;
  border-color: var(--ws-ink);
}
.ws-btn-dark:hover { background: var(--ws-soft); border-color: var(--ws-line-2); color: var(--ws-ink); }
.ws-btn-dark:disabled { opacity: 0.4; cursor: not-allowed; }
.ws-btn-ghost { background: transparent; border-color: transparent; color: var(--ws-ink-3); }
.ws-btn-ghost:hover { background: var(--ws-soft); color: var(--ws-ink); }
.ws-btn-sm { padding: 5px 10px; font-size: 12px; }

/* ===== Chat ===== */
.ws-chat-welcome {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
}
.ws-chat-welcome .ws-home-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 4vh;
  margin-bottom: 24px;
}
.ws-chat-body-welcome {
  max-width: none;
  padding: 0 32px;
}
.ws-chat-starters {
  padding-bottom: 8px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}
.ws-chat-starters .ws-starters-grid {
  width: 100%;
}
.ws-chat-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
}
.ws-chat-body-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  padding: 12px 32px 0;
  min-height: 100%;
}
.ws-chat-body-welcome .ws-chat-body-inner {
  padding: 0 32px;
}
.ws-chat-body .pr-thinking { max-width: 720px; padding: 0 20px; }
.ws-chat-thread {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-bottom: 24px;
}
.ws-chat-daymark {
  text-align: center;
  font-size: 10.5px;
  letter-spacing: 0.18em;
  font-weight: 600;
  color: var(--ws-ink-4);
  padding: 6px 0;
}

.ws-chat-row { display: flex; gap: 14px; align-items: flex-start; }
.ws-chat-row.ws-me { justify-content: flex-end; }

.ws-chat-bubble-me {
  max-width: 72%;
  background: var(--ws-ink);
  color: #e8f9f8;
  padding: 11px 16px;
  border-radius: 18px 18px 4px 18px;
  font-size: 14px;
  line-height: 1.45;
}

.ws-chat-meta {
  display: flex; align-items: baseline; gap: 8px;
  margin-bottom: 4px;
}
.ws-chat-name { font-weight: 600; color: var(--ws-ink); font-size: 13.5px; }
.ws-chat-role { font-size: 11.5px; color: var(--ws-ink-4); }
.ws-chat-time { font-size: 11px; color: var(--ws-ink-5); margin-left: auto; }

.ws-chat-bubble-agent {
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--ws-ink-2);
  max-width: 640px;
}

.ws-chat-actions {
  display: flex; align-items: center; gap: 4px;
  margin-top: 6px;
  opacity: 0;
  transition: opacity 0.12s;
}
.ws-chat-row:hover .ws-chat-actions { opacity: 1; }
.ws-chat-actions button {
  border: 0; background: transparent;
  padding: 4px 6px;
  border-radius: 5px;
  color: var(--ws-ink-4);
  display: grid; place-items: center;
  cursor: pointer;
}
.ws-chat-actions button:hover { background: var(--ws-soft); color: var(--ws-ink-2); }

/* ===== Starters ===== */
.ws-starters-bar {
  display: flex; align-items: center; gap: 16px;
  padding: 8px 0 4px;
}
.ws-starters-bar-spacer { flex: 1; }
.ws-starters-toggle {
  display: inline-flex; align-items: center; gap: 4px;
  background: transparent; border: 0; padding: 4px 0;
  font-size: 12px; font-weight: 450; color: var(--ws-ink-4);
  cursor: pointer;
}
.ws-starters-toggle:hover { color: var(--ws-ink-2); }
.ws-starters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}
.ws-starter-card {
  display: flex; align-items: flex-start; gap: 12px;
  padding: 14px;
  background: #ffffff;
  border: 0.5px solid var(--ws-line-2);
  border-radius: var(--ws-r-md);
  text-align: left;
  transition: border-color 0.15s;
  cursor: pointer;
  font-family: var(--ws-sans);
}
.ws-starter-card:hover {
  border-color: rgba(29, 61, 72, 0.3);
}
.ws-starters-more {
  display: inline-flex; align-items: center; gap: 4px;
  background: transparent; border: 0; padding: 8px 0 0;
  font-family: var(--ws-sans); font-size: 12px; font-weight: 500;
  color: var(--ws-ink-4);
  cursor: pointer;
}
.ws-starters-more:hover { color: var(--ws-accent); }
.ws-starter-icon {
  width: 28px; height: 28px; border-radius: 7px;
  background: var(--ws-soft);
  display: grid; place-items: center;
  color: var(--ws-ink-2);
  flex-shrink: 0;
}
.ws-starter-title { font-size: 13.5px; font-weight: 600; color: var(--ws-ink); margin-bottom: 2px; }
.ws-starter-sub { font-size: 12px; color: var(--ws-ink-4); line-height: 1.4; }

/* ===== Home cards (capability quartet) ===== */
.ws-chat-starters:has(.ws-home-cards) {
  container-type: inline-size;
}
.ws-home-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  width: 100%;
}
@container (max-width: 640px) {
  .ws-home-cards { grid-template-columns: 1fr; }
}
.ws-home-card {
  --ws-home-tint: var(--ws-ink-3);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 20px 14px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  text-align: left;
  font-family: var(--ws-sans);
  color: inherit;
  cursor: pointer;
  transition: border-color 0.18s ease, transform 0.18s ease, background 0.18s ease;
}
.ws-home-card:hover {
  border-color: color-mix(in srgb, var(--ws-home-tint) 45%, var(--ws-line));
  background: color-mix(in srgb, var(--ws-home-tint) 2%, var(--ws-panel));
}
.ws-home-card:focus-visible {
  outline: none;
  border-color: var(--ws-home-tint);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ws-home-tint) 18%, transparent);
}
.ws-home-card-head {
  display: flex;
  align-items: center;
  gap: 11px;
}
.ws-home-card-icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  color: var(--ws-home-tint);
  background: color-mix(in srgb, var(--ws-home-tint) 10%, transparent);
  flex-shrink: 0;
}
.ws-home-card-titles {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.ws-home-card-title {
  font-family: var(--ws-serif);
  font-size: 18px;
  font-weight: 500;
  line-height: 1.15;
  color: var(--ws-ink);
  letter-spacing: -0.005em;
}
.ws-home-card-tagline {
  font-size: 12px;
  font-style: italic;
  color: var(--ws-ink-4);
  line-height: 1.3;
}
.ws-home-card-body {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ws-ink-3);
}
.ws-home-card-examples {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ws-home-card-examples li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: var(--ws-ink-3);
}
.ws-home-card-examples li svg {
  color: var(--ws-home-tint);
  opacity: 0.85;
  flex-shrink: 0;
}
/* Short viewports: trim the quartet so all four cards + the composer fit
   without the page looking cramped. Drops the examples and tightens spacing,
   mirroring the latest-preview height guard below. */
@media (max-height: 860px) {
  .ws-home-card { padding: 13px 16px 11px; gap: 7px; }
  .ws-home-card-examples { display: none; }
  .ws-home-card-title { font-size: 16px; }
  .ws-home-card-body { font-size: 12px; }
  .ws-home-card-cta { padding-top: 6px; }
}
.ws-home-card-latest {
  padding-top: 10px;
  border-top: 1px solid var(--ws-line);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
@media (max-height: 900px) {
  .ws-home-card-latest { display: none; }
}
.ws-home-card-latest-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--ws-ink-5);
}
.ws-home-card-latest-row {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}
.ws-home-card-latest-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  background: var(--ws-ink-5);
}
.ws-home-card-latest-dot.ws-home-card-latest-ok { background: var(--ws-ok); }
.ws-home-card-latest-dot.ws-home-card-latest-warn { background: var(--ws-warn); }
.ws-home-card-latest-dot.ws-home-card-latest-mute { background: var(--ws-ink-5); }
.ws-home-card-latest-title {
  font-size: 12.5px;
  color: var(--ws-ink-2);
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ws-home-card-latest-status {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ws-ink-5);
  flex-shrink: 0;
}
.ws-home-card-latest-status.ws-home-card-latest-ok { color: var(--ws-ok); }
.ws-home-card-latest-status.ws-home-card-latest-warn { color: var(--ws-warn); }
.ws-home-card-cta {
  margin-top: auto;
  padding-top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ws-home-tint);
  letter-spacing: 0.005em;
}
.ws-home-card-cta svg {
  transition: transform 0.18s ease;
}
.ws-home-card:hover .ws-home-card-cta svg {
  transform: translateX(2px);
}

/* ===== Composer ===== */
.ws-agent-created-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  margin: 0 auto 8px;
  max-width: 880px;
  width: 100%;
  background: var(--ws-bg);
  border: 1px solid var(--ws-border);
  border-radius: 10px;
}
.ws-agent-created-banner strong { font-weight: 600; }
.ws-btn-sm { padding: 6px 12px; font-size: 13px; gap: 4px; }

.ws-composer-wrap {
  position: relative;
  padding: 16px 32px 24px;
  background: var(--ws-bg);
  margin: 0 auto;
  max-width: calc(880px + 64px); /* 880 content + 32px gutter each side */
  width: 100%;
  flex-shrink: 0;
}
.ws-composer {
  display: flex; align-items: center;
  padding: 6px 6px 6px 14px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line-2);
  border-radius: 999px;
  box-shadow: var(--ws-shadow-md);
  gap: 8px;
}
.ws-composer:focus-within { border-color: var(--ws-ink-3); box-shadow: var(--ws-shadow-lg); }
.ws-composer input {
  flex: 1;
  border: 0; outline: none; background: transparent;
  font-size: 14.5px;
  padding: 8px 0;
  color: var(--ws-ink);
  font-family: var(--ws-sans);
}
.ws-composer-tool {
  border: 0; background: transparent;
  color: var(--ws-ink-4);
  padding: 7px;
  border-radius: 50%;
  display: grid; place-items: center;
  cursor: pointer;
}
.ws-composer-tool:hover { color: var(--ws-ink-2); background: var(--ws-soft); }
.ws-composer-route {
  display: flex; align-items: center; gap: 6px;
  font-size: 11.5px; color: var(--ws-ink-4);
  border-left: 1px solid var(--ws-line);
  padding-left: 10px;
  margin-right: 4px;
  white-space: nowrap;
}
.ws-composer-send {
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 0;
  background: var(--ws-soft);
  color: var(--ws-ink-5);
  display: grid; place-items: center;
  transition: all 0.15s;
  cursor: pointer;
  flex-shrink: 0;
}
.ws-composer-send.ws-on { background: var(--ws-ink); color: #e8f9f8; }
.ws-composer-hint {
  font-size: 11.5px; color: var(--ws-ink-4);
  text-align: center;
  margin-top: 10px;
}
.ws-agent-chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 3px 9px 3px 4px;
  border-radius: 999px;
  background: white;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: var(--ws-ink-2);
}
.ws-trace-ev-body .ws-agent-chip {
  border: none; background: transparent; padding: 0; gap: 4px;
}
.ws-agent-chip .ws-sw {
  width: 16px; height: 16px; border-radius: 5px;
  display: grid; place-items: center;
  color: white; font-family: var(--ws-serif); font-size: 10px; font-weight: 700;
}

/* ===== Empty state / hero ===== */
.ws-empty {
  flex: 1;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: 60px 32px 32px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}
.ws-empty-hero {
  width: 56px; height: 56px;
  border-radius: 14px;
  background: linear-gradient(145deg, #182b35, #1d3d48);
  color: #e8f9f8;
  display: grid; place-items: center;
  font-family: var(--ws-serif);
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
  overflow: hidden;
}
.ws-empty-hero img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ws-empty-hero:has(img) { background: transparent; }
.ws-empty-greeting {
  font-size: 13px;
  color: var(--ws-ink-4);
  margin-bottom: 6px;
}
.ws-empty h1 {
  font-family: var(--ws-sans);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0 0 8px;
  color: var(--ws-ink);
}
.ws-empty p {
  font-size: 14.5px;
  color: var(--ws-ink-3);
  max-width: 460px;
  text-align: center;
  line-height: 1.5;
  margin: 0 0 28px;
}

/* ===== Agent page ===== */
.ws-agent-page {
  flex: 1; overflow: auto;
}
.ws-agent-page-inner {
  padding: 12px 40px 60px;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}
.ws-mission-split {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: start;
}
.ws-agent-hero { display: flex; gap: 10px; align-items: center; margin-bottom: 0; }
.ws-agent-hero-sw {
  width: 28px; height: 28px; border-radius: 7px;
  display: grid; place-items: center;
  color: white;
  font-family: var(--ws-serif); font-weight: 600; font-size: 13px;
  overflow: hidden; flex-shrink: 0;
}
.ws-agent-hero-sw:has(img) { background: transparent !important; }
.ws-agent-hero-name {
  font-family: var(--ws-serif);
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--ws-ink);
  line-height: 1.1;
}

.ws-agent-hero-actions {
  display: flex; gap: 6px; align-items: center; margin-left: auto;
}

.ws-agent-spend-inline {
  display: flex; align-items: center; gap: 8px;
  margin-left: auto; padding: 4px 10px;
  border-radius: 6px; background: var(--ws-soft);
}
.ws-agent-spend-inline.warn { background: #FEF6EE; }
.ws-agent-spend-inline.err { background: #FEF2F0; }
.ws-agent-spend-inline-text {
  font-size: 12px; font-weight: 500; color: var(--ws-ink-3);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.ws-agent-spend-inline.warn .ws-agent-spend-inline-text { color: var(--ws-warn); }
.ws-agent-spend-inline.err .ws-agent-spend-inline-text { color: var(--ws-err); }
.ws-agent-spend-inline-bar {
  width: 60px; height: 4px; background: var(--ws-line);
  border-radius: 2px; overflow: hidden;
}
.ws-agent-spend-inline-fill {
  height: 100%; border-radius: 2px; transition: width 0.2s;
}
.ws-agent-spend-inline-fill.ok { background: var(--ws-ink-3); }
.ws-agent-spend-inline-fill.warn { background: var(--ws-warn); }
.ws-agent-spend-inline-fill.err { background: var(--ws-err); }

.ws-agent-tabs {
  display: flex; gap: 20px;
  border-bottom: 1px solid var(--ws-line);
  margin: 4px 0 12px;
}
.ws-agent-tab {
  padding: 10px 2px;
  color: var(--ws-ink-4);
  font-size: 13.5px; font-weight: 500;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  border-top: 0; border-left: 0; border-right: 0;
  background: transparent;
  font-family: var(--ws-sans);
}
.ws-agent-tab:hover { color: var(--ws-ink-3); }
.ws-agent-tab.active { color: var(--ws-ink); border-bottom-color: var(--ws-ink); font-weight: 600; }

.ws-agent-page--chat {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 0;
}
.ws-agent-page--chat > .ws-agent-page-inner {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding-bottom: 0;
}
.ws-agent-page--chat .ws-agent-hero { flex-shrink: 0; }
.ws-agent-page--chat .ws-agent-tabs { flex-shrink: 0; }
.ws-agent-chat-embed {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin: 0 -40px;
}
.ws-agent-chat-embed .ws-content-row { flex: 1; }
.ws-agent-chat-embed .ws-chat-col { align-items: center; }


.ws-agent-section {
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-lg);
  padding: 24px 26px;
  margin-bottom: 18px;
}
.ws-agent-section h3 {
  font-family: var(--ws-serif);
  font-size: 18px; font-weight: 600;
  margin: 0 0 4px;
  color: var(--ws-ink);
  display: flex; align-items: center; gap: 8px;
  letter-spacing: -0.005em;
}
.ws-agent-section .ws-section-sub { font-size: 12.5px; color: var(--ws-ink-4); margin-bottom: 14px; }

.ws-company-profile-fields {
  display: flex; flex-direction: column; gap: 14px;
}
.ws-company-profile-field {
  display: flex; flex-direction: column; gap: 6px;
}
.ws-company-profile-field-label {
  font-size: 12.5px; font-weight: 600; color: var(--ws-ink);
}
.ws-company-profile-textarea {
  min-height: 64px;
}
.ws-company-profile-field-meta {
  font-size: 11.5px; color: var(--ws-ink-4); align-self: flex-end;
}

.ws-company-profile-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 12px; margin-bottom: 14px;
}
.ws-company-profile-header h3 { margin-bottom: 4px; }
.ws-company-profile-generate-btn {
  display: inline-flex; align-items: center; gap: 6px;
  white-space: nowrap; flex-shrink: 0;
}
.ws-company-profile-generate-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.ws-company-profile-actions {
  display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px;
}

.ws-identity-avatar-row {
  display: flex; align-items: center; gap: 14px; margin-bottom: 18px;
}
.ws-identity-avatar {
  width: 56px; height: 56px; border-radius: 14px;
  display: grid; place-items: center;
  font-family: var(--ws-serif); font-weight: 600; font-size: 24px;
  overflow: hidden; flex-shrink: 0;
}
.ws-identity-avatar:has(img) { background: transparent !important; }
.ws-identity-actions {
  display: flex; gap: 8px; justify-content: flex-end; margin-top: 6px;
}

.ws-agent-field { margin-bottom: 14px; }
.ws-agent-field-label {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4); margin-bottom: 5px;
}
.ws-agent-field-value {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 12px 14px;
  font-size: 13.5px; line-height: 1.5; color: var(--ws-ink-2);
}
.ws-agent-trust { padding: 10px 0; }
.ws-agent-trust-bar { display: flex; gap: 4px; margin-bottom: 8px; }
.ws-agent-trust-seg {
  width: 36px; height: 6px; border-radius: 3px;
  background: var(--ws-line); transition: background 0.2s;
}
.ws-agent-trust-seg.filled { background: var(--ws-ink); }
.ws-agent-trust-label { font-size: 13.5px; font-weight: 500; color: var(--ws-ink-2); }
.ws-agent-trust-sub { font-size: 12px; color: var(--ws-ink-4); margin-top: 4px; }
.ws-agent-field-value.ws-serif-quote {
  font-family: var(--ws-serif);
  font-size: 16px; font-style: italic; color: var(--ws-ink-2);
}

.ws-perm-header {
  display: grid;
  grid-template-columns: 140px repeat(4, 1fr);
  gap: 4px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
}
.ws-perm-row {
  display: grid;
  grid-template-columns: 140px repeat(4, 1fr);
  gap: 4px;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-row:last-child { border-bottom: none; }
.ws-perm-entity {
  font-size: 13px;
  color: var(--ws-ink);
  text-transform: capitalize;
}
.ws-perm-level {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ws-perm-dot {
  width: 20px; height: 20px;
  border-radius: 50%;
  border: 2px solid var(--ws-line-2);
  background: transparent;
  transition: background 0.15s, border-color 0.15s;
  display: block;
  padding: 0;
  cursor: default;
}
.ws-perm-dot--active {
  background: var(--ws-accent, #1d3d48);
  border-color: var(--ws-accent, #1d3d48);
}
.ws-perm-top-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}
.ws-perm-earn-hint {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  margin-top: 12px;
  background: var(--ws-soft);
  border-radius: var(--ws-r-sm);
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ws-ink-3);
}
.ws-perm-section-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  margin-bottom: 8px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: var(--ws-ink);
}
.ws-perm-section-title {
  font-size: 14px;
  font-weight: 600;
  font-family: var(--ws-sans);
}
.ws-perm-section-sub {
  font-size: 12px;
  color: var(--ws-ink-4);
  font-weight: 400;
  margin-left: 4px;
}
.ws-perm-cap-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}
.ws-perm-cap-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-cap-row:last-child { border-bottom: none; }
.ws-perm-cap-indicator {
  width: 10px; height: 10px;
  border-radius: 50%;
  border: 2px solid var(--ws-line-2);
  background: transparent;
  flex-shrink: 0;
}
.ws-perm-cap-indicator--active {
  background: var(--ws-ok);
  border-color: var(--ws-ok);
}
.ws-perm-cap-text {
  min-width: 0;
}
.ws-perm-cap-name {
  font-size: 13px;
  color: var(--ws-ink);
}
.ws-perm-cap-sub {
  font-size: 12px;
  color: var(--ws-ink-4);
  margin-top: 1px;
}
.ws-perm-readonly-card {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 18px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-soft);
}
.ws-perm-readonly-icon {
  width: 18px; height: 18px;
  color: var(--ws-ink-3);
  flex-shrink: 0;
  margin-top: 2px;
}
.ws-perm-readonly-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ws-ink);
  margin-bottom: 4px;
}
.ws-perm-readonly-body {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ws-ink-3);
}
.ws-perm-readonly-footer {
  margin-top: 12px;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--ws-ink-4);
  font-style: italic;
}
.ws-perm-granted-list {
  display: flex;
  flex-direction: column;
}
.ws-perm-granted-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-perm-granted-row:last-child { border-bottom: none; }
.ws-perm-level-badge {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--ws-accent, #1d3d48);
  color: white;
}
.ws-perm-progress-section {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--ws-line);
}
.ws-perm-progress-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
  margin-bottom: 8px;
  padding: 0 12px;
}
.ws-perm-progress-row {
  display: grid;
  grid-template-columns: 140px auto 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--ws-ink-2);
}
.ws-perm-progress-arrow {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--ws-ink-3);
}
.ws-perm-progress-bar {
  display: block;
  height: 4px;
  background: var(--ws-line);
  border-radius: 2px;
  overflow: hidden;
  min-width: 60px;
}
.ws-perm-progress-fill {
  display: block;
  height: 100%;
  background: var(--ws-accent, #1d3d48);
  transition: width 0.2s;
}
.ws-perm-progress-count {
  font-size: 12px;
  color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ws-agent-relationships {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.ws-rel-block {
  padding: 14px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-soft);
}
.ws-rel-block-head {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4); margin-bottom: 8px;
}
.ws-rel-agent-row {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 0;
  border-bottom: 1px dashed var(--ws-line);
  font-size: 13px; color: var(--ws-ink-2);
}
.ws-rel-agent-row:last-child { border-bottom: 0; }

.ws-kpi-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
.ws-kpi-card {
  padding: 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
}
.ws-kpi-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--ws-ink-4); font-weight: 600;
}
.ws-kpi-value {
  font-family: var(--ws-serif);
  font-size: 26px; font-weight: 600;
  color: var(--ws-ink); margin-top: 4px;
}
.ws-kpi-sub { font-size: 11.5px; color: var(--ws-ink-4); }

.ws-tool-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.ws-tool-card {
  padding: 12px 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
  display: flex; align-items: center; gap: 10px;
}
.ws-tool-icon {
  width: 28px; height: 28px; border-radius: 7px;
  background: white; display: grid; place-items: center;
  border: 1px solid var(--ws-line);
  color: var(--ws-ink-3); flex-shrink: 0;
}
.ws-tool-name { font-weight: 500; font-size: 13px; color: var(--ws-ink); }
.ws-tool-perms { font-size: 11px; color: var(--ws-ink-4); }
.ws-pill-ok {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px; font-weight: 500;
  color: var(--ws-ok);
  background: rgba(47,122,78,0.08);
  border: 1px solid rgba(47,122,78,0.18);
  margin-left: auto;
}

/* ===== Settings — memory rows, groups, dreams ===== */
.ws-mem-group-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 0; width: 100%;
  border: none; background: transparent;
  cursor: pointer; font-family: var(--ws-sans);
  font-size: 12.5px; color: var(--ws-ink-3);
}
.ws-mem-group-head:hover { background: var(--ws-soft); border-radius: var(--ws-r-sm); }
.ws-mem-group-tag {
  font-weight: 600; text-transform: capitalize; color: var(--ws-ink-3);
}
.ws-mem-group-count {
  margin-left: auto; font-size: 10px; color: var(--ws-ink-5);
}
.ws-mem-row {
  display: flex; align-items: flex-start; gap: 12px;
  padding: 10px 0 10px 22px;
  border-top: 1px solid var(--ws-line);
}
.ws-mem-row:hover { background: var(--ws-soft); border-radius: var(--ws-r-sm); }
.ws-mem-key {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3); margin-bottom: 2px;
}
.ws-mem-val {
  font-size: 13px; color: var(--ws-ink-2); line-height: 1.5;
}
.ws-mem-actions {
  display: flex; gap: 2px; opacity: 0; transition: opacity 0.12s;
  flex-shrink: 0;
}
.ws-mem-row:hover .ws-mem-actions { opacity: 1; }
.ws-mem-btn {
  border: 0; background: transparent; padding: 5px;
  border-radius: 5px; color: var(--ws-ink-4);
  cursor: pointer; display: grid; place-items: center;
}
.ws-mem-btn:hover { background: var(--ws-hover); color: var(--ws-ink-2); }
.ws-mem-input {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line-2);
  border-radius: var(--ws-r-sm);
  padding: 8px 10px; font-size: 13px;
  color: var(--ws-ink); outline: none;
  font-family: var(--ws-sans);
  width: 100%;
}
.ws-mem-input:focus { border-color: var(--ws-ink-3); }
.ws-conf {
  font-size: 11px; font-weight: 600; padding: 2px 6px;
  border-radius: 999px; flex-shrink: 0;
}
.ws-conf.hi { color: var(--ws-ok); background: rgba(47,122,78,0.08); }
.ws-conf.mid { color: var(--ws-warn); background: rgba(184,112,42,0.08); }
.ws-conf.lo { color: var(--ws-err); background: rgba(184,74,62,0.08); }
.ws-dream-entry {
  padding: 20px 26px; position: relative;
}
.ws-dream-date {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3);
  letter-spacing: 0.02em;
}
.ws-dream-body {
  font-size: 13.5px; color: var(--ws-ink-2); line-height: 1.6;
  white-space: pre-wrap;
}
.ws-dream-actions {
  position: absolute; top: 16px; right: 18px;
  opacity: 0; transition: opacity 0.12s;
}
.ws-dream-entry:hover .ws-dream-actions { opacity: 1; }
/* ===== Editable hero name ===== */
.ws-hero-name-editable {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: border-color 0.15s;
}
.ws-hero-name-editable:hover {
  border-bottom-color: var(--ws-ink-5);
}
.ws-hero-name-input {
  font-family: var(--ws-serif);
  font-size: 34px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--ws-ink);
  background: transparent;
  border: none;
  border-bottom: 2px solid var(--ws-ink-3);
  outline: none;
  padding: 0;
  margin: 0;
  line-height: 1.05;
  width: 100%;
}
.ws-hero-title-editable {
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: border-color 0.15s;
}
.ws-hero-title-editable:hover {
  border-bottom-color: var(--ws-ink-5);
}
.ws-hero-title-input {
  font-size: 13px;
  color: var(--ws-ink-4);
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--ws-ink-3);
  outline: none;
  padding: 0;
  margin: 0;
  font-family: var(--ws-sans);
  width: 200px;
}

@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* Animated ellipsis for inline loading text — content jumps at each keyframe
   (it can't interpolate), so it cycles . .. ... without a steps() timing fn. */
.ws-ellipsis::after { content: '.'; animation: ws-ellipsis 1.4s infinite; }
@keyframes ws-ellipsis {
  0%, 100% { content: '.'; }
  33% { content: '..'; }
  66% { content: '...'; }
}

/* ===== Scrollbar — autohide ===== */
/* Thumb is fully transparent at rest; fades in only while hovering a scrollable
   container (or while actively dragging). Track is always transparent so the
   gutter doesn't visually reserve space.

   Scoped to known scrollable elements (not the universal selector) to avoid
   restyling every descendant in long chats on every hover. Add new scrollable
   classes to the list below as they appear. */
.ai-ws ::-webkit-scrollbar { width: 10px; height: 10px; }
.ai-ws ::-webkit-scrollbar-track { background: transparent; }
.ai-ws ::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
  transition: background-color 160ms ease;
}
.ai-ws .ws-chat-body:hover::-webkit-scrollbar-thumb,
.ai-ws .ws-sb-scrollable:hover::-webkit-scrollbar-thumb,
.ai-ws .ws-side-panel-body:hover::-webkit-scrollbar-thumb,
.ai-ws .ws-trace-body:hover::-webkit-scrollbar-thumb { background-color: rgba(0,0,0,0.14); }
.ai-ws ::-webkit-scrollbar-thumb:hover { background-color: rgba(0,0,0,0.24); }
.ai-ws ::-webkit-scrollbar-thumb:active { background-color: rgba(0,0,0,0.32); }
/* Firefox */
.ai-ws .ws-chat-body,
.ai-ws .ws-sb-scrollable,
.ai-ws .ws-side-panel-body,
.ai-ws .ws-trace-body { scrollbar-color: transparent transparent; scrollbar-width: thin; }
.ai-ws .ws-chat-body:hover,
.ai-ws .ws-sb-scrollable:hover,
.ai-ws .ws-side-panel-body:hover,
.ai-ws .ws-trace-body:hover { scrollbar-color: rgba(0,0,0,0.2) transparent; }

/* Override praxis/shadcn styles inside the workspace chat area */
.ai-ws .praxis {
  --pr-surface: var(--ws-bg);
  background: transparent;
  border: none;
  border-radius: 0;
}
.ai-ws .pr-date-divider::before { background: var(--ws-bg); }
.ai-ws .pr-date-divider { background: var(--ws-bg); }
.ai-ws .praxis .sticky { background: var(--ws-bg); }
.ai-ws .praxis .pr-shell-header { display: none; }
.ai-ws .praxis .pr-sidebar { display: none; }
.ai-ws .praxis .pr-chat-main { background: transparent; }
.ai-ws .praxis .pr-composer-wrap {
  max-width: 880px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.ai-ws .praxis .pr-empty {
  padding-top: 0;
}

/* ChatInput (pr-* classes) styled for workspace */
.ai-ws .pr-composer-wrap {
  padding: 0 0 24px;
  background: var(--ws-bg);
  border-top: none;
}
.ai-ws .pr-composer { max-width: none; margin: 0; }
.ai-ws .pr-composer-box {
  --pr-surface: var(--ws-panel);
  --pr-border: var(--ws-line);
  --pr-r-lg: var(--ws-r-lg);
  --pr-accent: var(--ws-accent);
  --pr-accent-soft-2: rgba(19,17,14,0.06);
  --pr-accent-soft: rgba(19,17,14,0.04);
  background: var(--ws-panel);
  border-color: var(--ws-line);
  border-radius: 14px;
  padding: 8px 10px 4px;
  box-shadow: 0 1px 2px rgba(15, 23, 32, 0.04), 0 4px 14px rgba(15, 23, 32, 0.04);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}
.ai-ws .pr-composer-box.compact {
  padding: 4px 6px 4px 10px;
  border-radius: var(--ws-r-lg);
  box-shadow: none;
}
.ai-ws .pr-composer-box:hover {
  box-shadow: 0 1px 2px rgba(15, 23, 32, 0.05), 0 6px 18px rgba(15, 23, 32, 0.06);
}
.ai-ws .pr-composer-box.focused {
  border-color: var(--ws-ink-3);
  box-shadow: 0 0 0 3px rgba(19,17,14,0.06), 0 4px 16px rgba(15, 23, 32, 0.06);
}
.ai-ws .pr-composer-textarea {
  font-family: var(--ws-sans);
  font-size: 14px;
  line-height: 1.45;
  color: var(--ws-ink);
  min-height: 30px;
}
.ai-ws .pr-composer-box.compact .pr-composer-textarea {
  font-size: 14px;
  line-height: 1.4;
  min-height: 20px;
}
.ai-ws .pr-composer-textarea::placeholder { color: var(--ws-ink-4); }
.ai-ws .pr-composer-tool {
  color: var(--ws-ink-3);
  border-radius: var(--ws-r-sm);
}
.ai-ws .pr-composer-tool:hover { color: var(--ws-ink); background: var(--ws-soft); }
.ai-ws .pr-send-btn {
  background: var(--ws-accent);
  color: #e8f9f8;
  border-radius: 999px;
  width: 32px;
  height: 32px;
}
.ai-ws .pr-composer-box.compact .pr-send-btn {
  border-radius: var(--ws-r-sm);
  width: 30px;
  height: 30px;
}
.ai-ws .pr-send-btn:hover { background: #16323b; }
.ai-ws .pr-send-btn:disabled { background: var(--ws-soft); color: var(--ws-ink-5); }

/* ===== Sidebar conversation actions (rename / delete) ===== */
.ws-sb-item-hoverable { position: relative; overflow: hidden; }
.ws-sb-actions {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 1px;
  opacity: 0;
  pointer-events: none;
  padding: 0 6px 0 18px;
  background: linear-gradient(to right, transparent 0%, var(--ws-hover) 30%);
  transition: opacity 0.1s;
}
.ws-sb-item-hoverable:hover { padding-right: 76px; }
.ws-sb-item-hoverable:hover .ws-sb-actions { opacity: 1; pointer-events: auto; }
.ws-sb-item-hoverable.active .ws-sb-actions { background: linear-gradient(to right, transparent 0%, #e4eaf0 30%); }
.ws-sb-action-btn {
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px;
  border-radius: var(--ws-r-sm);
  color: var(--ws-ink-4);
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  background: none; border: none; padding: 0;
}
.ws-sb-action-btn:hover { color: var(--ws-ink); background: var(--ws-hover); }
.ws-sb-action-starred { color: var(--ws-ink-3); }
.ws-sb-action-starred:hover { color: var(--ws-ink); }
.ws-sb-action-confirm { color: #C62828 !important; }
.ws-sb-action-confirm:hover { color: #B71C1C !important; background: rgba(198,40,40,0.08); }
.ws-sb-confirm-delete { background: rgba(198,40,40,0.04); }
.ws-sb-edit-input {
  flex: 1; min-width: 0;
  background: none; border: none; outline: none;
  font: inherit; font-size: 13px;
  color: var(--ws-ink);
  border-bottom: 1px solid var(--ws-ink-4);
  padding: 0 0 1px;
}

/* ===== Content row (chat + side panel) ===== */
.ws-content-row {
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.ws-chat-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
}

/* Extend the date-divider backdrop enough to cover the run-section's extra-wide sticky header
   (which uses calc(100% + 48px)), but not -100vw which causes horizontal scroll in the grid. */
.ai-ws .pr-date-divider::before { left: -48px; right: -48px; }
.ai-ws .pr-prose pre { max-width: 100%; }
.ai-ws .pr-prose table { display: block; overflow-x: auto; max-width: 100%; }

/* ===== Run-based conversation overrides ===== */
.ai-ws .pr-run-bucket-head {
  font-family: var(--ws-sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--ws-ink-4);
  border-bottom: none;
  padding: 16px 0 6px;
}
.ai-ws .pr-run-bucket-head:not(:first-child) {
  border-top: 1px solid var(--ws-line);
  margin-top: 8px;
  padding-top: 20px;
}
.ai-ws .pr-run-bucket-head:hover { color: var(--ws-ink-3); }
.ai-ws .pr-run-bucket-chev { color: var(--ws-ink-5); }
.ai-ws .pr-run-bucket-count {
  color: var(--ws-ink-5);
  font-weight: 450;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: none;
}
.ai-ws .border-t-2.border-border {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}
.ai-ws .pr-row-icon {
  color: var(--ws-ink-4);
}
.ai-ws .pr-row-icon svg {
  width: 13px;
  height: 13px;
}
/* Run row sticky header */
.ai-ws .border-t-2.border-border > button {
  font-family: var(--ws-sans);
  border-radius: var(--ws-r-sm);
}
.ai-ws .border-t-2.border-border > button:hover {
  background: var(--ws-hover) !important;
}
.ai-ws .border-t-2.border-border > button .text-body-sm {
  font-family: var(--ws-sans);
  font-size: 13px;
  color: var(--ws-ink-3);
}
.ai-ws .border-t-2.border-border > button .text-grey-7,
.ai-ws .border-t-2.border-border > button .text-grey-8 {
  color: var(--ws-ink-4);
}

/* ===== User bubble override ===== */
.ai-ws .pr-user-bubble {
  background: var(--ws-ink-2);
  color: #c3e8e8;
  border: none;
  border-radius: 18px 18px 4px 18px;
  padding: 12px 18px;
  font-size: 14.5px;
  line-height: 1.5;
}
.ai-ws .pr-user-bubble a {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}
.ai-ws .pr-user-bubble a:hover {
  background: rgba(255, 255, 255, 0.24);
}

/* ===== Home view ===== */
.ws-home {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.ws-home-content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px 16px;
}
.ws-home-bottom {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px 24px;
}
.ws-home-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}
.ws-home-hero h1 {
  font-family: var(--ws-sans);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--ws-ink);
}

/* ===== Home feed ===== */
.ws-feed {
  width: 100%;
  max-width: 680px;
  margin-bottom: 28px;
}
.ws-feed-head {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
  margin-bottom: 10px;
}
.ws-feed-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  margin-bottom: 6px;
  cursor: pointer;
  background: var(--ws-panel);
  width: 100%;
  text-align: left;
  font-family: var(--ws-sans);
  transition: border-color 0.15s, background 0.15s;
}
.ws-feed-item:hover {
  border-color: var(--ws-line-2);
  background: white;
}
.ws-feed-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: var(--ws-ink-3);
}
.ws-feed-icon-sched { background: rgba(74,107,133,0.1); color: var(--ws-a-forecasting); }
.ws-feed-icon-hook { background: rgba(95,127,106,0.1); color: var(--ws-a-prospecting); }
.ws-feed-body {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ws-feed-label {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--ws-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.ws-feed-time {
  font-size: 12px;
  color: var(--ws-ink-4);
  flex-shrink: 0;
}

/* ===== Automation pages (scheduled / hooks) ===== */
.ws-auto-page {
  padding: 32px 40px;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}
.ws-auto-section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
  margin-bottom: 14px;
}
.ws-auto-new-btn {
  margin-left: auto;
  text-transform: none;
  letter-spacing: 0;
  font-size: 13px;
}
.ws-auto-empty {
  padding: 40px 20px;
  text-align: center;
  color: var(--ws-ink-4);
  font-size: 14px;
}
.ws-auto-row {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  margin-bottom: 8px;
  cursor: pointer;
  background: var(--ws-panel);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.ws-auto-row:hover { border-color: var(--ws-line-2); }
.ws-auto-row-expanded {
  border-color: var(--ws-line-2);
  box-shadow: var(--ws-shadow-sm);
  cursor: default;
}
.ws-auto-row-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
}
.ws-auto-row-disabled { opacity: 0.55; cursor: default; }
.ws-auto-icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  background: rgba(74,107,133,0.1);
  color: var(--ws-a-forecasting);
  flex-shrink: 0;
}
.ws-auto-icon-hook {
  background: rgba(95,127,106,0.1);
  color: var(--ws-a-prospecting);
}
.ws-auto-info {
  flex: 1;
  min-width: 0;
}
.ws-auto-label {
  font-weight: 500;
  font-size: 15px;
  color: var(--ws-ink);
}
.ws-auto-meta {
  font-size: 13px;
  color: var(--ws-ink-4);
  margin-top: 2px;
}
.ws-auto-runs-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: var(--ws-r-sm);
  border: none;
  background: transparent;
  color: var(--ws-ink-4);
  font-size: 12px;
  font-weight: 500;
  font-family: var(--ws-sans);
  cursor: pointer;
  transition: color 0.12s, background 0.12s;
  flex-shrink: 0;
}
.ws-auto-runs-link:hover { color: var(--ws-ink-2); background: var(--ws-soft); }
.ws-auto-toggle {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 10px;
  border: none;
  background: var(--ws-line-2);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;
  padding: 0;
}
.ws-auto-toggle.on { background: var(--ws-ink); }
.ws-auto-toggle-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
  transition: transform 0.2s;
}
.ws-auto-toggle.on .ws-auto-toggle-knob { transform: translateX(16px); }

/* ===== Automation inline settings ===== */
.ws-auto-settings {
  border-top: 1px solid var(--ws-line);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ws-auto-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ws-auto-field-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ws-ink-4);
}
.ws-auto-input {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 9px 12px;
  font-size: 14px;
  color: var(--ws-ink);
  outline: none;
  font-family: var(--ws-sans);
  transition: border-color 0.15s;
}
.ws-auto-input:focus { border-color: var(--ws-ink-3); }
.ws-auto-textarea {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 9px 12px;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--ws-ink);
  outline: none;
  font-family: var(--ws-sans);
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.15s;
}
.ws-auto-textarea:focus { border-color: var(--ws-ink-3); }
.ws-auto-trigger-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  font-size: 13px;
  color: var(--ws-ink-2);
  font-weight: 500;
  width: fit-content;
  text-transform: capitalize;
}
.ws-auto-filters {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 9px 12px;
  font-size: 13px;
  color: var(--ws-ink-3);
  line-height: 1.5;
}
.ws-auto-schedule-editor {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 12px 14px;
}
.ws-auto-schedule-editor button {
  font-family: var(--ws-sans);
  color: var(--ws-ink-3);
}
.ws-auto-schedule-editor button:hover {
  color: var(--ws-ink);
}
.ws-auto-schedule-editor select {
  font-family: var(--ws-sans);
  background: white;
  border-color: var(--ws-line);
  color: var(--ws-ink);
}
.ws-auto-schedule-editor select:focus {
  border-color: var(--ws-ink-3);
}
.ws-auto-schedule-editor .bg-grey-11 {
  background: var(--ws-ink) !important;
}
.ws-auto-schedule-editor .bg-grey-2 {
  background: white !important;
  border: 1px solid var(--ws-line);
}
.ws-auto-schedule-editor .bg-grey-2:hover {
  background: var(--ws-soft) !important;
}
.ws-auto-schedule-editor .text-grey-9 {
  color: var(--ws-ink-4) !important;
}
.ws-auto-schedule-editor .text-grey-13 {
  color: var(--ws-ink) !important;
}
.ws-auto-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 4px;
}
.ws-auto-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: var(--ws-r-sm);
  border: 1px solid var(--ws-line);
  background: transparent;
  color: var(--ws-ink-3);
  font-size: 12.5px;
  font-weight: 500;
  font-family: var(--ws-sans);
  cursor: pointer;
  transition: all 0.12s;
}
.ws-auto-action-btn:hover { background: var(--ws-soft); color: var(--ws-ink); border-color: var(--ws-line-2); }
.ws-auto-action-danger:hover { color: var(--ws-err); border-color: rgba(184,74,62,0.3); background: rgba(184,74,62,0.04); }
.ws-auto-confirm-delete {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ws-auto-delete-yes {
  padding: 5px 12px;
  border-radius: var(--ws-r-sm);
  background: var(--ws-err);
  color: white;
  font-size: 12px;
  font-weight: 600;
  font-family: var(--ws-sans);
  border: none;
  cursor: pointer;
}
.ws-auto-delete-yes:hover { opacity: 0.9; }
.ws-auto-delete-no {
  padding: 5px 12px;
  border-radius: var(--ws-r-sm);
  background: transparent;
  color: var(--ws-ink-3);
  font-size: 12px;
  font-weight: 500;
  font-family: var(--ws-sans);
  border: none;
  cursor: pointer;
}
.ws-auto-delete-no:hover { background: var(--ws-soft); }
.ws-auto-save-btn {
  padding: 7px 18px;
  border-radius: var(--ws-r-sm);
  border: 1px solid var(--ws-line);
  background: var(--ws-soft);
  color: var(--ws-ink-4);
  font-size: 13px;
  font-weight: 600;
  font-family: var(--ws-sans);
  cursor: not-allowed;
  transition: all 0.15s;
}
.ws-auto-save-btn.ws-auto-dirty {
  background: var(--ws-ink);
  color: #e8f9f8;
  border-color: var(--ws-ink);
  cursor: pointer;
}
.ws-auto-save-btn.ws-auto-dirty:hover { background: var(--ws-ink-2); }
.ws-auto-save-btn.ws-auto-saved {
  background: var(--ws-ok);
  color: white;
  border-color: var(--ws-ok);
  cursor: default;
}

/* Organization sidebar split item */
.ws-sb-item-main {
  display: flex; align-items: center; gap: 10px;
  flex: 1; min-width: 0;
  border: 0; background: transparent; padding: 0;
  color: inherit; font: inherit; cursor: pointer;
  text-align: left;
}
.ws-sb-item-chev {
  border: 0; background: transparent; padding: 4px;
  cursor: pointer; color: inherit;
  display: grid; place-items: center;
  border-radius: 4px;
  margin-left: auto;
}
.ws-sb-item-chev:hover { background: rgba(0,0,0,0.06); }

/* Nested sidebar items */
.ws-sb-item-nested { padding-left: 32px; }
.ws-sb-item-muted { color: var(--ws-ink-4); font-size: 12.5px; }

/* Routine row leading marker — neutral by default, future home for
   run-status signal (red on error, amber on stale). */
.ws-sb-routine-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ws-ink-4);
  opacity: 0.5;
  flex-shrink: 0;
  margin: 0 5px;
}


/* ===== Organization view ===== */
.ws-org-layout {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 360px;
  min-height: 0;
  overflow: hidden;
}
.ws-org-canvas {
  overflow: auto;
  background: var(--ws-bg);
  position: relative;
}
.ws-org-canvas-inner {
  padding: 48px 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  position: relative;
  min-height: 100%;
}
.ws-org-grid-bg {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle at 1px 1px, rgba(0,0,0,0.05) 1px, transparent 0);
  background-size: 20px 20px;
  opacity: 0.6;
  pointer-events: none;
}
.ws-org-level { display: flex; justify-content: center; position: relative; z-index: 1; }
.ws-org-level-row { display: flex; gap: 18px; justify-content: center; margin-top: 20px; flex-wrap: wrap; align-items: stretch; }
.ws-org-tree-node { display: flex; flex-direction: column; align-items: center; }
.ws-org-connector {
  width: 1.5px; height: 34px;
  background: var(--ws-line);
  margin: 14px 0;
  position: relative; z-index: 0;
}
.ws-org-branch-wrap {
  width: 100%; max-width: 720px;
  height: 20px;
  position: relative;
  margin-top: 14px;
}
.ws-org-branch-line {
  position: absolute;
  left: 12%; right: 12%; top: 0;
  height: 1.5px;
  background: var(--ws-line);
}

/* Org cards */
.ws-org-card {
  background: white;
  border: 1.5px solid var(--ws-line);
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 200px;
  max-width: 240px;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(.4,0,.2,1);
  position: relative;
  box-shadow: 0 1px 2px rgba(19,17,14,0.04);
}
.ws-org-card[draggable="true"] {}
.ws-org-card:hover {
  border-color: var(--ws-ink-4);
  box-shadow: 0 4px 16px rgba(19,17,14,0.06), 0 1px 2px rgba(19,17,14,0.04);
  transform: translateY(-1px);
}
.ws-org-card.selected {
  border: 1.5px solid #2F7A4E;
  box-shadow: 0 0 0 4px rgba(47,122,78,0.08), 0 4px 16px rgba(19,17,14,0.06);
}
.ws-org-card-human {
  background: linear-gradient(180deg, #f6f9fb, #edf1f5);
  border-color: rgba(184,147,90,0.35);
  cursor: default;
}
.ws-org-card-human:hover { transform: none; }
.ws-org-card-lead {
  background: linear-gradient(180deg, #FFFFFF, #f6f9fb);
}
.ws-org-card-head { display: flex; gap: 10px; align-items: center; }
.ws-org-card-sw {
  width: 28px; height: 28px; border-radius: 7px;
  display: grid; place-items: center;
  color: white;
  font-family: var(--ws-serif);
  font-weight: 600;
  font-size: 13px;
  flex-shrink: 0;
  overflow: hidden;
}
.ws-org-card-title-col { min-width: 0; flex: 1; }
.ws-org-card-name {
  font-family: var(--ws-serif);
  font-weight: 600;
  font-size: 15.5px;
  color: var(--ws-ink);
  line-height: 1.15;
  letter-spacing: -0.005em;
}
.ws-org-card-role { font-size: 11.5px; color: var(--ws-ink-4); margin-top: 1px; }
.ws-org-card-meta {
  display: flex; align-items: center; justify-content: space-between;
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px dashed var(--ws-line);
  font-size: 11px;
  color: var(--ws-ink-4);
}
.ws-org-status { display: inline-flex; align-items: center; gap: 5px; font-weight: 500; }
.ws-org-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--ws-ink-4);
}
.ws-org-status.active { color: #2F7A4E; }
.ws-org-status.active .ws-org-dot {
  background: #2F7A4E;
  box-shadow: 0 0 0 2px rgba(47,122,78,0.18);
}
.ws-org-pill-dark {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 1px 6px;
  border-radius: 999px;
  background: var(--ws-ink);
  color: #e8f9f8;
}

/* Org tabs */
.ws-org-tabs {
  display: flex; align-items: center; gap: 4px;
  justify-content: center;
  border-bottom: 1px solid var(--ws-line);
  padding: 16px 40px 0;
}
.ws-org-tabs button {
  padding: 10px 14px 10px 12px;
  border: 0; background: transparent;
  color: var(--ws-ink-4); font-family: var(--ws-sans);
  font-size: 13px; font-weight: 500;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  display: inline-flex; align-items: center; gap: 6px;
  cursor: pointer;
}
.ws-org-tabs button.active { color: var(--ws-ink); border-bottom-color: var(--ws-ink); font-weight: 600; }
.ws-org-tab-count {
  font-size: 11px; background: var(--ws-soft); padding: 0 6px;
  border-radius: 9px; color: var(--ws-ink-4); font-weight: 500;
}

/* Team list */
.ws-team-list {
  display: flex; flex-direction: column; gap: 0;
  width: 100%; max-width: 520px;
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
}
.ws-team-list-header {
  display: grid; grid-template-columns: 1fr auto;
  align-items: center; gap: 8px;
  padding: 10px 16px;
  font-size: 10.5px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
  background: var(--ws-soft); border-bottom: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md) var(--ws-r-md) 0 0;
}
.ws-team-row {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 16px; cursor: pointer;
  transition: background 0.1s;
}
.ws-team-row + .ws-team-row { border-top: 1px solid var(--ws-line); }
.ws-team-row:hover { background: var(--ws-soft); }
.ws-team-row.selected { background: rgba(19,17,14,0.04); }
.ws-team-row-info {
  flex: 1; min-width: 0;
  display: flex; flex-direction: column; gap: 1px;
}
.ws-team-row-owner { font-size: 12px; color: var(--ws-ink-3); }
.ws-team-row-role { font-size: 11.5px; color: var(--ws-ink-4); }

/* Inspector */
.ws-org-inspector {
  border-left: 1px solid var(--ws-line);
  background: white;
  padding: 28px 24px;
  overflow: auto;
  display: flex; flex-direction: column; gap: 18px;
}
.ws-oi-head { display: flex; gap: 12px; align-items: center; }
.ws-oi-sw { width: 36px; height: 36px; font-size: 15px; border-radius: 9px; }
.ws-oi-name {
  font-family: var(--ws-serif);
  font-size: 20px; font-weight: 600;
  color: var(--ws-ink); line-height: 1.1;
}
.ws-oi-role { font-size: 12px; color: var(--ws-ink-4); margin-top: 2px; }
.ws-oi-section { display: flex; flex-direction: column; gap: 8px; }
.ws-oi-section-head {
  font-size: 10.5px; font-weight: 600; letter-spacing: 0.1em;
  text-transform: uppercase; color: var(--ws-ink-4);
  display: flex; align-items: center; gap: 6px;
}
.ws-oi-section-body {
  font-size: 13.5px; line-height: 1.5; color: var(--ws-ink-3);
}
.ws-oi-vision {
  font-family: var(--ws-serif);
  font-size: 15px; font-style: italic;
  color: var(--ws-ink-3);
}
.ws-oi-list {
  margin: 0; padding-left: 0;
  list-style: none;
  font-size: 13px; line-height: 1.45;
  color: var(--ws-ink-3);
  display: flex; flex-direction: column; gap: 6px;
}
.ws-oi-list li {
  padding-left: 18px;
  position: relative;
}
.ws-oi-list li::before {
  content: ''; position: absolute;
  left: 0; top: 7px;
  width: 10px; height: 1.5px;
  background: var(--ws-ink-4);
}
.ws-oi-chips { display: flex; flex-wrap: wrap; gap: 5px; }
.ws-oi-chip {
  display: inline-flex; align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px; font-weight: 500;
  background: var(--ws-bg);
  color: var(--ws-ink-3);
  border: 1px solid var(--ws-line);
}
.ws-oi-open-btn {
  display: flex; align-items: center; justify-content: center; gap: 7px;
  width: 100%;
  padding: 9px 14px;
  border-radius: 999px;
  border: 0;
  background: var(--ws-ink);
  color: #e8f9f8;
  font-size: 13px; font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.12s;
}
.ws-oi-open-btn:hover { background: #244856; }

/* Agent color vars */
.ai-ws { --ws-a-human: #B8935A; }

/* ===== Task queue — header ===== */
.ws-tasks-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 28px 32px 0; max-width: 1100px; margin: 0 auto; width: 100%; box-sizing: border-box;
}
.ws-tasks-header-left { display: flex; flex-direction: column; gap: 2px; }
.ws-tasks-title {
  font-family: var(--ws-serif); font-size: 28px; font-weight: 700;
  color: var(--ws-ink); margin: 0; line-height: 1.2;
}
.ws-tasks-subtitle {
  font-size: 13px; color: var(--ws-ink-4); font-family: var(--ws-sans);
}
.ws-tasks-header-actions {
  display: flex; align-items: center; gap: 8px;
}

/* View toggle (segmented control) */
.ws-view-toggle {
  display: inline-flex; padding: 3px; gap: 2px;
  background: var(--ws-soft); border-radius: 8px;
}
.ws-view-toggle button {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 12px; border: 0; background: transparent;
  font-size: 12.5px; font-weight: 500; color: var(--ws-ink-3);
  cursor: pointer; border-radius: 6px; font-family: var(--ws-sans);
}
.ws-view-toggle button.on {
  background: var(--ws-panel); color: var(--ws-ink);
  box-shadow: 0 1px 2px rgba(19,17,14,0.06);
}

.ws-tasks-hdr-link {
  display: inline-flex; align-items: center; gap: 5px;
  border: none; background: none; padding: 7px 12px;
  font-size: 13px; font-weight: 500; font-family: var(--ws-sans);
  color: var(--ws-ink-3); cursor: pointer; transition: color 0.12s;
}
.ws-tasks-hdr-link:hover { color: var(--ws-ink); }
.ws-tasks-hdr-primary {
  display: inline-flex; align-items: center; gap: 6px;
  border: 1px solid var(--ws-ink); border-radius: var(--ws-r-md);
  padding: 7px 16px; font-size: 13px; font-weight: 500;
  font-family: var(--ws-sans); color: var(--ws-ink);
  background: transparent; cursor: pointer; transition: all 0.15s;
}
.ws-tasks-hdr-primary:hover { background: var(--ws-ink); color: var(--ws-bg); }

/* ===== Task queue — body ===== */
.ws-tasks {
  padding: 0 32px 24px; max-width: 1100px; margin: 0 auto;
  width: 100%; box-sizing: border-box; overflow-y: auto; flex: 1; min-height: 0;
}
.ws-tasks-sticky-header {
  position: sticky; top: 0; z-index: 3; background: var(--ws-bg);
  padding-top: 20px; padding-bottom: 0;
}
.ws-tasks-empty { padding: 60px 20px; text-align: center; color: var(--ws-ink-4); font-size: 13px; }

/* Filter card container */
.ws-tq-filters {
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 10px 12px;
  margin-bottom: 12px;
}
.ws-tq-filter-row {
  display: flex; flex-wrap: wrap; align-items: center;
  gap: 8px 10px; padding: 4px 0;
}
.ws-tq-filter-row + .ws-tq-filter-row {
  border-top: 1px dashed var(--ws-line);
  margin-top: 4px; padding-top: 8px;
}

/* Search inside filter card */
.ws-tasks-search {
  flex: 1; min-width: 240px;
  display: flex; align-items: center; gap: 8px;
  padding: 8px 12px; background: var(--ws-soft);
  border: 1px solid transparent; border-radius: 8px;
  transition: border-color 0.12s;
}
.ws-tasks-search:focus-within { border-color: var(--ws-ink-5); background: var(--ws-panel); }
.ws-tasks-search input {
  flex: 1; background: transparent; border: none; outline: none;
  font-family: var(--ws-sans); font-size: 13px; color: var(--ws-ink);
}
.ws-tasks-search input::placeholder { color: var(--ws-ink-4); }

/* Filter chips */
.ws-tq-chip-group {
  display: inline-flex; align-items: center; gap: 4px; flex-wrap: wrap;
}
.ws-tq-chip-label {
  font-size: 10.5px; font-weight: 600; color: var(--ws-ink-4);
  text-transform: uppercase; letter-spacing: 0.08em; margin-right: 4px;
}
.ws-tq-chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 10px; border: 1px solid var(--ws-line);
  background: var(--ws-panel); border-radius: 999px;
  font-family: var(--ws-sans); font-size: 12px; color: var(--ws-ink-2);
  cursor: pointer; transition: all 0.12s;
}
.ws-tq-chip:hover { border-color: var(--ws-ink-5); }
.ws-tq-chip.on {
  background: var(--ws-ink); border-color: var(--ws-ink); color: #e8f9f8;
}
.ws-tq-chip.on .ws-tq-ct { background: rgba(255,255,255,0.18); color: #e8f9f8; }
.ws-tq-chip.warn.on { background: var(--ws-warn); border-color: var(--ws-warn); color: #4A2A0A; }
.ws-tq-chip.ok.on { background: #2F7A4E; border-color: #2F7A4E; }
.ws-tq-chip.err.on { background: #C9462C; border-color: #C9462C; }
.ws-tq-chip.info.on { background: var(--ws-info); border-color: var(--ws-info); }
.ws-tq-ct {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 18px; height: 16px; padding: 0 5px;
  background: var(--ws-soft); border-radius: 8px;
  font-size: 10.5px; font-weight: 600; color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
}
.ws-tq-chip-agent { padding: 3px 10px 3px 4px; }
.ws-tq-chip-agent .ws-agent-chip { pointer-events: none; }
.ws-tq-chip-agent.on {
  background: var(--ws-panel);
  border: 2px solid var(--ws-ink-2);
  padding: 2px 9px 2px 3px;
  color: var(--ws-ink);
}
.ws-tq-chip-ghost {
  border-color: transparent; color: var(--ws-ink-3); background: transparent;
  margin-left: auto;
}
.ws-tq-chip-ghost:hover { background: var(--ws-soft); color: var(--ws-ink); }
.ws-tq-chip-ghost:disabled { color: var(--ws-ink-5); cursor: default; }
.ws-tq-chip-ghost:disabled:hover { background: transparent; color: var(--ws-ink-5); }

/* GROUP BY + SORT controls row */
.ws-tasks-controls-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 12px; flex-wrap: wrap; margin-bottom: 10px; padding: 0 2px;
}
.ws-tasks-controls-left, .ws-tasks-controls-right {
  display: inline-flex; align-items: center; gap: 8px;
}
.ws-tq-segmented {
  display: inline-flex; padding: 2px; gap: 2px;
  background: var(--ws-soft); border-radius: 7px;
}
.ws-tq-segmented button {
  padding: 5px 10px; border: 0; background: transparent;
  font-family: var(--ws-sans); font-size: 12px; color: var(--ws-ink-3);
  cursor: pointer; border-radius: 5px;
}
.ws-tq-segmented button.on {
  background: var(--ws-panel); color: var(--ws-ink); font-weight: 600;
  box-shadow: 0 1px 2px rgba(19,17,14,0.06);
}

/* Table card */
.ws-tq-table {
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: 0 0 var(--ws-r-md) var(--ws-r-md);
  border-top: 0;
}

/* Table grid — 7 columns: dot + task + chain + status + duration + cost + when */
.ws-tbl-header, .ws-tbl-row {
  display: grid;
  grid-template-columns: 14px minmax(200px, 2fr) minmax(140px, 1.2fr) 80px 80px 70px minmax(130px, auto);
  gap: 14px; align-items: center; padding: 10px 14px;
}
.ws-tbl-header {
  font-size: 10.5px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
  background: var(--ws-soft); border-bottom: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md) var(--ws-r-md) 0 0;
}
.ws-tbl-header span:nth-child(n+5):nth-child(-n+6) { text-align: right; }
.ws-tbl-row {
  border-bottom: 1px solid var(--ws-line);
  cursor: pointer; transition: background 0.1s; font-size: 13px;
}
.ws-tbl-row:last-child { border-bottom: 0; }
.ws-tbl-row:hover { background: var(--ws-soft); }
.ws-tbl-row.needs-you { background: rgba(184,112,42,0.03); }

/* Status dots */
.ws-tq-dot {
  width: 8px; height: 8px; border-radius: 50%; background: var(--ws-ink-5);
}
.ws-tq-dot.todo { background: var(--ws-ink-5); }
.ws-tq-dot.in_progress { background: var(--ws-info); box-shadow: 0 0 0 3px rgba(59,107,168,0.2); }
.ws-tq-dot.blocked { background: var(--ws-warn); }
.ws-tq-dot.done { background: #2F7A4E; }
.ws-tq-dot.cancelled { background: var(--ws-ink-5); opacity: 0.5; }

/* Task cell */
.ws-tbl-cell-task { min-width: 0; }
.ws-tbl-task-top {
  display: flex; align-items: center; gap: 8px;
  font-weight: 500; color: var(--ws-ink);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ws-tbl-task-id {
  font-family: var(--ws-mono); font-size: 10.5px; color: var(--ws-ink-4);
  background: var(--ws-soft); padding: 1px 6px; border-radius: 4px;
  flex-shrink: 0;
}
.ws-tbl-task-title {
  font-weight: 500; color: var(--ws-ink); font-size: 13px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ws-tbl-task-sub {
  margin-top: 3px; font-size: 12px; color: var(--ws-ink-3);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ws-tasks-row-action { color: var(--ws-ink-2); font-weight: 500; }

/* Chain cell */
.ws-tbl-cell-chain { min-width: 0; justify-self: start; }
.ws-chain {
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
  font-size: 11.5px;
}
.ws-chain-arrow { color: var(--ws-ink-4); font-size: 11px; }

/* Status pill in table row */
.ws-tq-pill {
  display: inline-flex; align-items: center; padding: 2px 8px;
  border-radius: 999px; font-size: 11px; font-weight: 500;
  background: var(--ws-soft); color: var(--ws-ink-3);
  justify-self: start;
}
.ws-tq-pill.warn { background: rgba(184,112,42,0.12); color: var(--ws-warn); }
.ws-tq-pill.info { background: rgba(59,107,168,0.12); color: var(--ws-info); }
.ws-tq-pill.ok { background: rgba(47,122,78,0.12); color: #2F7A4E; }
.ws-tq-pill.err { background: rgba(201,70,44,0.12); color: #C9462C; }

/* Mono cells (tools, duration, cost) */
.ws-tbl-cell-mono {
  font-variant-numeric: tabular-nums;
  font-size: 12.5px; color: var(--ws-ink-2);
  text-align: right;
}

/* When cell */
.ws-tbl-cell-when {
  font-size: 12px; color: var(--ws-ink-3); white-space: nowrap;
  position: relative;
}
.ws-tbl-row-actions {
  display: none; position: absolute; right: 0; top: 50%;
  transform: translateY(-50%); background: var(--ws-soft);
  padding: 2px 4px; border-radius: var(--ws-r-sm);
}
.ws-tbl-row:hover .ws-tbl-row-actions { display: flex; gap: 4px; }
.ws-tasks-action-btn {
  display: grid; place-items: center;
  width: 26px; height: 26px; border-radius: var(--ws-r-sm);
  border: none; background: transparent; cursor: pointer;
  color: var(--ws-ink-4); transition: all 0.12s;
}
.ws-tasks-action-cancel:hover { color: var(--ws-err); background: rgba(184,74,62,0.08); }
.ws-tasks-action-retry:hover { color: var(--ws-info); background: rgba(59,107,168,0.08); }
.ws-tasks-action-btn:disabled { opacity: 0.4; cursor: default; }

/* Groups */
.ws-tq-group { }
.ws-tq-group + .ws-tq-group .ws-tq-group-head { border-top: 1px solid var(--ws-line); }
.ws-tq-group-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px 8px;
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-3);
  background: var(--ws-soft); border-bottom: 1px solid var(--ws-line);
  position: sticky; z-index: 2;
}
.ws-tq-group-ct {
  font-size: 10.5px; color: var(--ws-ink-4); font-weight: 500;
  font-variant-numeric: tabular-nums;
}

/* ===== Pagination ===== */
.ws-tasks-pagination {
  display: flex; align-items: center; justify-content: center;
  gap: 12px; padding: 16px 0 8px;
}
.ws-tasks-page-btn {
  display: grid; place-items: center;
  width: 28px; height: 28px; border-radius: var(--ws-r-sm);
  border: 1px solid var(--ws-line); background: var(--ws-panel);
  cursor: pointer; color: var(--ws-ink-2); transition: all 0.12s;
}
.ws-tasks-page-btn:hover:not(:disabled) { background: var(--ws-soft); }
.ws-tasks-page-btn:disabled { opacity: 0.35; cursor: default; }
.ws-tasks-page-info {
  font-size: 12px; color: var(--ws-ink-3); font-variant-numeric: tabular-nums;
}

/* ===== Activity log ===== */
.ws-activity { padding: 24px 32px; max-width: 1100px; margin: 0 auto; }
.ws-activity-filters { display: flex; align-items: center; gap: 12px; margin: 12px 0 16px; }
.ws-activity-filters .ws-tasks-tabs { flex-wrap: wrap; flex: 1; min-width: 0; }
.ws-activity-select {
  appearance: none; -webkit-appearance: none;
  background: var(--ws-panel) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E") no-repeat right 10px center;
  border: 1px solid var(--ws-line); border-radius: var(--ws-r-sm);
  padding: 6px 28px 6px 12px; font-size: 12.5px; font-family: var(--ws-sans);
  color: var(--ws-ink-2); cursor: pointer; white-space: nowrap;
}
.ws-activity-select:hover { border-color: var(--ws-ink-4); color: var(--ws-ink); }
.ws-activity-select:focus { outline: none; border-color: var(--ws-ink-3); }
.ws-activity-row {
  display: grid; grid-template-columns: auto 1fr auto auto;
  gap: 10px; align-items: center; padding: 10px 8px;
  border-bottom: 1px solid var(--ws-line); cursor: pointer;
}
.ws-activity-row:hover { background: var(--ws-hover); }
.ws-activity-row-status {
  display: inline-flex; align-items: center; padding: 2px 8px;
  border-radius: 999px; font-size: 11px; font-weight: 500;
  background: var(--ws-soft); color: var(--ws-ink-3);
}
.ws-activity-row-status.running { background: rgba(59,107,168,0.12); color: var(--ws-info); }
.ws-activity-row-status.succeeded { background: rgba(47,122,78,0.12); color: var(--ws-ok); }
.ws-activity-row-status.failed { background: rgba(184,74,62,0.12); color: var(--ws-err); }
.ws-activity-row-status.awaiting_approval { background: rgba(184,112,42,0.12); color: var(--ws-warn); }
.ws-activity-row-status.awaiting_input { background: rgba(184,112,42,0.12); color: var(--ws-warn); }
.ws-activity-row-status.cancelled { background: var(--ws-soft); color: var(--ws-ink-4); }
.ws-activity-badge {
  display: inline-flex; align-items: center; gap: 3px;
  padding: 2px 7px; border-radius: 999px;
  font-size: 10px; font-weight: 500; flex-shrink: 0;
  white-space: nowrap;
}
.ws-activity-badge.delegated { background: rgba(59,107,168,0.10); color: var(--ws-info); }
.ws-activity-badge.approval { background: rgba(184,112,42,0.10); color: var(--ws-warn); }
.ws-reply-preview {
  padding: 10px 14px; margin: 0 0 8px;
  background: var(--ws-soft); border-radius: var(--ws-r-sm);
}
.ws-reply-preview-text {
  margin: 0; font-size: 13px; line-height: 1.55;
  color: var(--ws-ink-2); word-break: break-word;
  white-space: pre-wrap;
}
.ws-reply-preview-link {
  display: inline-flex; align-items: center; gap: 4px;
  margin-top: 8px; padding: 0; border: 0; background: none;
  font-size: 12px; font-weight: 500; color: var(--ws-ink-3);
  cursor: pointer; font-family: var(--ws-sans);
}
.ws-reply-preview-link:hover { color: var(--ws-ink); }
.ws-outcome-preview { display: flex; flex-direction: column; gap: 6px; }
.ws-outcome-summary {
  margin: 0; font-size: 13px; line-height: 1.5; color: var(--ws-ink-1);
  white-space: pre-wrap; word-break: break-word;
}
.ws-outcome-toggle {
  display: inline-block; margin-top: 4px; padding: 0; border: none; background: none;
  font-size: 12px; color: var(--ws-ink-4); cursor: pointer; font-family: var(--ws-sans);
}
.ws-outcome-toggle:hover { color: var(--ws-ink-2); }
.ws-outcome-question {
  margin: 0; font-size: 12.5px; line-height: 1.5; color: var(--ws-warn);
  display: flex; align-items: flex-start; gap: 5px;
}
.ws-work-items-list { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 2px; }
/* Right-align the delegation chip list under a message (matches the right-aligned
   delegated-result tag in the header). */
.ws-work-items-list--end { justify-content: flex-end; }
.ws-work-item-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 8px; border-radius: 999px; font-size: 11.5px; font-weight: 500;
  background: rgba(47,122,78,0.10); color: var(--ws-ok);
  white-space: nowrap; max-width: 280px; overflow: hidden;
}
/* Truncate the label (not the whole flex row) so a long title gets an ellipsis
   while the leading/trailing icons stay visible and the pill keeps its shape.
   min-width:0 lets the label shrink below its content in the flex row. */
.ws-work-item-chip > span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* Delegation chip shares the neutral palette of the delegated-result tag. */
.ws-work-item-chip--delegation {
  background: var(--ws-soft); color: var(--ws-ink-4);
}
button.ws-work-item-chip {
  border: 0; cursor: pointer; font-family: inherit;
}
button.ws-work-item-chip--delegation {
  border: 1px solid var(--ws-line-2);
}
button.ws-work-item-chip--clickable:hover {
  filter: brightness(0.96);
}
/* Banner above a delegated-work *result* message in the parent conversation —
   makes it unmistakable the summary came back from a background delegated run,
   and opens that child conversation in the drawer on click. */
.ws-delegation-result-header {
  display: flex; align-items: center; gap: 6px;
  width: 100%; margin: 0 0 8px; padding: 7px 12px;
  border: 1px solid var(--ws-line-2); border-radius: var(--ws-r-md);
  background: rgba(59,107,168,0.06);
  font-family: inherit; font-size: 12px; font-weight: 500;
  color: var(--ws-ink-3); cursor: pointer; text-align: left;
  transition: background 0.12s, border-color 0.12s;
}
.ws-delegation-result-header:hover { background: rgba(59,107,168,0.10); border-color: var(--ws-info); }
.ws-delegation-result-label { color: var(--ws-ink-4); }
.ws-delegation-result-dot { color: var(--ws-ink-5); }
.ws-delegation-result-agent { color: var(--ws-ink); font-weight: 600; }
/* Compact inline variant rendered in the message header row (right of name/time). */
.ws-delegation-result-tag {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 1px 8px; border-radius: 999px;
  border: 1px solid var(--ws-line-2); background: var(--ws-soft);
  font-family: inherit; font-size: 11px; font-weight: 500; line-height: 1.7;
  color: var(--ws-ink-4); cursor: pointer;
  transition: background 0.12s, border-color 0.12s, color 0.12s;
}
.ws-delegation-result-tag:hover { background: var(--ws-hover); border-color: var(--ws-info); color: var(--ws-ink-2); }
.ws-summary-draft-panel {
  flex-basis: 100%;
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: var(--ws-r-sm);
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  display: flex; flex-direction: column; gap: 8px;
}
.ws-summary-draft-section-head {
  font-size: 10.5px; font-weight: 600; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--ws-ink-4);
}
.ws-summary-draft-section-head--risk { color: var(--ws-red); }
.ws-summary-draft-text {
  margin: 0; font-size: 12.5px; line-height: 1.5;
  color: var(--ws-ink-1); white-space: pre-wrap; word-break: break-word;
}
.ws-summary-draft-watchout { display: flex; flex-direction: column; gap: 6px; }
.ws-summary-draft-watchout-item {
  display: flex; flex-direction: column; gap: 2px;
}
.ws-summary-draft-watchout-issue {
  font-size: 12.5px; font-weight: 500; color: var(--ws-ink-1);
}
.ws-summary-draft-watchout-action {
  font-size: 12px; color: var(--ws-ink-4);
}
/* Email-draft expand panel — preview of subject/body + resolved signature.
 * The signature HTML comes from the server (already templated), and is
 * rendered verbatim so the rep sees exactly what will be sent. */
.ws-email-draft-panel {
  flex-basis: 100%;
  margin: 4px 0 8px;
  padding: 10px 12px;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  background: var(--ws-soft);
  font-size: 12px;
  display: flex; flex-direction: column;
}
.ws-email-draft-subject { font-weight: 600; margin-bottom: 6px; color: var(--ws-ink-1); }
.ws-email-draft-body { white-space: pre-wrap; margin: 0 0 8px; color: var(--ws-ink-1); }
.ws-email-draft-signature {
  border-top: 1px dashed var(--ws-line);
  padding-top: 6px;
  margin-bottom: 8px;
  color: var(--ws-ink-4);
}
.ws-email-draft-signature p { margin: 0 0 2px 0; }
.ws-email-draft-signature img { max-width: 200px; height: auto; }
.ws-contact-diff-panel { gap: 10px; }
.ws-contact-diff-list { display: flex; flex-direction: column; gap: 4px; }
.ws-contact-diff-row {
  display: grid; grid-template-columns: 60px 1fr auto 1fr;
  gap: 6px; align-items: baseline;
  font-size: 12.5px;
}
.ws-contact-diff-label { font-weight: 600; color: var(--ws-ink-1); }
.ws-contact-diff-current { color: var(--ws-ink-4); }
.ws-contact-diff-arrow { color: var(--ws-ink-4); }
.ws-contact-diff-next { color: var(--ws-ink-1); font-weight: 500; }
.ws-contact-diff-error {
  font-size: 12px; color: var(--ws-red);
}
.ws-contact-diff-actions {
  display: flex; justify-content: flex-end; gap: 6px;
}
.ws-activity-row-time { font-size: 12px; color: var(--ws-ink-4); }
.ws-activity-events-inline {
  background: var(--ws-soft); border-radius: var(--ws-r-sm);
  padding: 12px; margin: 4px 0 12px;
}

/* ===== Trace drawer ===== */
.ws-trace-backdrop {
  position: fixed; inset: 0; background: rgba(19,17,14,0.32);
  z-index: 9990; backdrop-filter: blur(2px);
}
.ws-trace-drawer {
  position: fixed; top: 0; right: 0; bottom: 0;
  min-width: 400px; max-width: 85vw;
  background: var(--ws-panel); border-left: 1px solid var(--ws-line);
  box-shadow: var(--ws-shadow-lg); z-index: 9991;
  display: flex; flex-direction: column; overflow: hidden;
}
.ws-trace-drawer.is-resizing { transition: none; user-select: none; }
.ws-trace-resize-handle {
  position: absolute; top: 0; left: -3px; bottom: 0; width: 7px;
  cursor: col-resize; z-index: 3;
  background: transparent;
}
.ws-trace-resize-handle::after {
  content: ''; position: absolute; top: 0; left: 3px; bottom: 0; width: 1px;
  background: transparent; transition: background 120ms ease;
}
.ws-trace-resize-handle:hover::after,
.ws-trace-drawer.is-resizing .ws-trace-resize-handle::after {
  background: var(--ws-info);
}
.ws-trace-header {
  display: flex; flex-direction: column; gap: 6px;
  padding: 12px 20px; border-bottom: 1px solid var(--ws-line);
  position: sticky; top: 0; z-index: 2;
  background: var(--ws-panel);
}
.ws-trace-header-top {
  display: flex; align-items: center; gap: 8px;
}
.ws-trace-pill--id {
  font-family: var(--ws-mono); font-size: 11px; font-weight: 500;
  color: var(--ws-ink-3); background: var(--ws-soft);
  padding: 2px 8px; border-radius: 999px;
  border: 1px solid var(--ws-line);
}
.ws-trace-status {
  font-size: 11px; padding: 2px 8px; border-radius: 999px;
  background: var(--ws-soft); color: var(--ws-ink-3); text-transform: capitalize;
  border: 1px solid var(--ws-line);
}
.ws-trace-status-needs-reply { background: #FFF3E0; color: #E65100; border-color: rgba(230,81,0,0.2); }
.ws-trace-status-needs-approval { background: #FFF3E0; color: #E65100; border-color: rgba(230,81,0,0.2); }
.ws-trace-status-blocked { background: #FFEBEE; color: var(--ws-err); border-color: rgba(184,74,62,0.2); }
.ws-trace-status-requeued { background: #E8F5E9; color: #2E7D32; border-color: rgba(46,125,50,0.2); }
.ws-trace-status-running { background: #E8F5E9; color: #2E7D32; border-color: rgba(46,125,50,0.2); }
.ws-trace-status-live {
  display: inline-flex; align-items: center; gap: 5px;
  background: rgba(59,107,168,0.08); color: var(--ws-info);
  border-color: rgba(59,107,168,0.25);
}
.ws-trace-live-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--ws-info); flex-shrink: 0;
  animation: ws-pulse 1.5s ease-in-out infinite;
}
@keyframes ws-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(59,107,168,0.5); }
  50% { opacity: 0.7; box-shadow: 0 0 0 4px rgba(59,107,168,0); }
}
.ws-trace-meta-time {
  font-size: 11.5px; color: var(--ws-ink-3); font-variant-numeric: tabular-nums;
  margin-left: 4px;
}
.ws-trace-header-actions {
  margin-left: auto;
  display: inline-flex; align-items: center; gap: 2px;
}
.ws-trace-header-action {
  background: transparent; border: 0;
  cursor: pointer; padding: 4px; border-radius: 4px; color: var(--ws-ink-3);
  display: inline-flex; align-items: center; justify-content: center;
}
.ws-trace-header-action:hover { background: var(--ws-hover); color: var(--ws-ink-2); }
.ws-trace-title {
  font-family: var(--ws-serif); font-size: 18px; font-weight: 500;
  margin: 0; line-height: 1.3; letter-spacing: -0.01em;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  flex: 1; min-width: 0;
}
.ws-trace-title-placeholder { flex: 1; min-width: 0; }
.ws-trace-header-meta {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.ws-trace-body { flex: 1; overflow-y: auto; scrollbar-gutter: stable; padding: 10px 20px 18px; }
.ws-trace-meta-inline {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  font-size: 13px; color: var(--ws-ink-3);
}
.ws-trace-meta-sep { color: var(--ws-ink-4); }
.ws-trace-meta-label { color: var(--ws-ink-4); }
.ws-trace-origin {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 8px; margin-top: 2px;
  background: var(--ws-soft); border: 1px solid var(--ws-line);
  border-radius: 999px;
  font-family: var(--ws-sans); font-size: 12px; color: var(--ws-ink-3);
  cursor: pointer; transition: background 120ms ease, color 120ms ease;
  align-self: flex-start;
}
.ws-trace-origin:hover:not(:disabled) { background: var(--ws-hover); color: var(--ws-ink-1); }
.ws-trace-origin:disabled { cursor: default; opacity: 0.7; }
.ws-trace-origin-label { color: var(--ws-ink-4); }
.ws-trace-origin-name { font-weight: 500; color: var(--ws-ink-2); }
.ws-trace-summary {
  margin: 0 0 16px; background: #FEF6EE; border: 1px solid rgba(184,112,42,0.2);
  border-radius: var(--ws-r-md); padding: 14px 16px;
}
.ws-trace-section-head {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-4); margin-bottom: 8px;
}
.ws-trace-summary .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-summary p { margin: 0; font-size: 13.5px; line-height: 1.55; color: var(--ws-ink-2); white-space: pre-wrap; }
.ws-trace-summary-muted { color: var(--ws-ink-4) !important; font-style: italic; }
.ws-trace-summary-prompt {
  margin-top: 10px !important; padding-top: 10px;
  border-top: 1px solid rgba(184,112,42,0.18);
  color: var(--ws-ink-2);
}
.ws-trace-outcome {
  margin: 16px 0; background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 14px 16px;
}
.ws-trace-outcome .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-outcome .ws-outcome-summary { font-size: 13.5px; }
.ws-trace-reply {
  margin: 16px 0; background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 14px 16px;
}
.ws-trace-reply .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-reply-body {
  margin: 0; font-size: 13.5px; line-height: 1.55; color: var(--ws-ink-1);
  white-space: pre-wrap; word-break: break-word;
}
.ws-trace-preview-wrap { margin: 18px 0; display: flex; flex-direction: column; gap: 8px; }
.ws-trace-preview {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 12px 14px;
}
.ws-trace-preview-headline {
  font-size: 13.5px; font-weight: 600; color: var(--ws-ink);
  margin-bottom: 8px;
}
.ws-trace-preview-empty {
  font-size: 12.5px; color: var(--ws-ink-4); font-style: italic;
}
.ws-trace-preview-rows {
  display: flex; flex-direction: column; gap: 4px;
}
.ws-trace-preview-row {
  display: grid; grid-template-columns: minmax(110px, 22%) 1fr; gap: 10px;
  font-size: 12.5px; line-height: 1.5;
}
.ws-trace-preview--collapsed {
  display: flex; align-items: center; gap: 8px; cursor: pointer;
  width: 100%; text-align: left;
}
.ws-trace-preview--collapsed .ws-trace-preview-headline {
  margin-bottom: 0; font-size: 13px; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
.ws-trace-preview-collapse-btn {
  display: flex; align-items: center; gap: 6px;
  background: none; border: none; padding: 0; margin-bottom: 6px;
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3);
  cursor: pointer;
}
.ws-trace-preview-collapse-btn:hover { color: var(--ws-ink); }
.ws-trace-preview-key { color: var(--ws-ink-4); text-transform: capitalize; }
/* Loop targets (selectedIds) — these aren't editable fields like the rest;
 * they're the records we'll iterate. Distinct treatment so users don't
 * mistake them for a per-record property. */
.ws-trace-preview-targets {
  display: flex; flex-direction: column; gap: 6px;
  margin: 4px 0 10px;
  padding: 8px 10px;
  background: rgba(60, 109, 182, 0.06);
  border: 1px dashed rgba(60, 109, 182, 0.35);
  border-radius: var(--ws-r-sm);
}
.ws-trace-preview-targets-head {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--ws-info, #3c6db6);
}
.ws-trace-preview-targets-icon { width: 12px; height: 12px; flex-shrink: 0; }
.ws-trace-preview-targets-label { line-height: 1; }
.ws-trace-preview-targets-ids {
  display: flex; flex-wrap: wrap; gap: 4px 5px;
  font-variant-numeric: tabular-nums;
}
.ws-trace-preview-target-chip {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 1px 7px;
  font-size: 11.5px;
  background: var(--ws-panel);
  border: 1px solid rgba(60, 109, 182, 0.25);
  border-radius: 3px;
  color: var(--ws-ink-2);
}
.ws-trace-preview-target-chip-name { color: var(--ws-ink); }
.ws-trace-preview-target-chip-id { color: var(--ws-ink-4); font-size: 10.5px; }
.ws-trace-preview-target-chip--more {
  font-weight: 600;
  color: var(--ws-info, #3c6db6);
  background: transparent;
  border-color: transparent;
}
.ws-trace-preview-val {
  color: var(--ws-ink-2); white-space: pre-wrap; overflow-wrap: anywhere;
}
.ws-trace-preview-val.is-editable {
  cursor: pointer; border-radius: 3px; padding: 1px 4px; margin: -1px -4px;
  transition: background 120ms;
}
.ws-trace-preview-val.is-editable:hover { background: rgba(19,17,14,0.06); }

/* Inline field editors */
.ws-inline-edit-cell { min-width: 0; position: relative; }
.ws-inline-edit-input {
  width: 100%; font-size: 12.5px; font-family: inherit;
  padding: 3px 6px; border: 1px solid var(--ws-line-2); border-radius: 4px;
  background: var(--ws-panel); color: var(--ws-ink);
  outline: none;
}
.ws-inline-edit-input:focus { border-color: var(--ws-accent); box-shadow: 0 0 0 2px rgba(19,17,14,0.08); }

/* Entity reference search editor */
.ws-inline-ref-editor { position: relative; }
.ws-inline-ref-input-row { display: flex; gap: 4px; align-items: center; }
.ws-inline-ref-clear {
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border: none; border-radius: 3px;
  background: none; color: var(--ws-ink-4); cursor: pointer; flex-shrink: 0;
}
.ws-inline-ref-clear:hover { background: var(--ws-hover); color: var(--ws-ink); }
.ws-inline-ref-dropdown {
  position: absolute; top: 100%; left: 0; right: 0; z-index: 20;
  max-height: 180px; overflow-y: auto;
  background: var(--ws-panel); border: 1px solid var(--ws-line-2);
  border-radius: 6px; margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.ws-inline-ref-row {
  display: block; width: 100%; text-align: left;
  padding: 6px 10px; font-size: 12.5px; color: var(--ws-ink);
  border: none; background: none; cursor: pointer;
}
.ws-inline-ref-row:hover { background: var(--ws-hover); }
.ws-inline-ref-row.is-selected { font-weight: 600; }
.ws-inline-ref-row--muted { color: var(--ws-ink-4); cursor: default; font-style: italic; }
.ws-inline-ref-row--muted:hover { background: none; }
.ws-inline-ref-tags { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 4px; }
.ws-inline-ref-tag {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 11.5px; padding: 2px 6px; border-radius: 4px;
  background: var(--ws-soft); color: var(--ws-ink-2); border: 1px solid var(--ws-line);
}
.ws-inline-ref-tag-x {
  display: inline-flex; border: none; background: none; padding: 0;
  color: var(--ws-ink-4); cursor: pointer;
}
.ws-inline-ref-tag-x:hover { color: var(--ws-ink); }
.ws-trace-comments { display: flex; flex-direction: column; gap: 12px; margin: 18px 0; }
.ws-trace-comment {
  background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 12px 14px;
}
.ws-trace-comment-header {
  display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
}
.ws-trace-comment-author {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3);
}
.ws-trace-comment-time {
  font-size: 11px; color: var(--ws-ink-4); margin-left: auto;
}
.ws-trace-comment-body {
  font-size: 13.5px; line-height: 1.6; color: var(--ws-ink-1);
  white-space: pre-wrap; word-break: break-word;
}
.ws-trace-comment-truncated {
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
  overflow: hidden;
}
.ws-trace-comment-toggle {
  background: none; border: none; padding: 0; margin-top: 4px;
  cursor: pointer; font-size: 12px; font-weight: 500; color: var(--ws-ink-4);
}
.ws-trace-comment-toggle:hover { color: var(--ws-ink-2); }
.ws-trace-section-toggle {
  display: flex; align-items: center; gap: 4px;
  background: none; border: none; padding: 0; margin: 0;
  cursor: pointer; font-size: 11px; font-weight: 600; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--ws-ink-4);
}
.ws-trace-section-toggle:hover { color: var(--ws-ink-2); }
.ws-trace-timeline-wrap { margin-top: 18px; }
.ws-trace-attachments { margin: 16px 0; }
.ws-trace-attachment-list { display: flex; flex-direction: column; gap: 2px; margin-top: 8px; }
.ws-trace-attachment-item {
  display: flex; align-items: center; gap: 10px; padding: 8px 10px;
  border-radius: var(--ws-r-sm); text-decoration: none; color: var(--ws-ink);
  transition: background 0.12s;
}
.ws-trace-attachment-item:hover { background: var(--ws-panel-hover); }
.ws-trace-attachment-info { display: flex; flex-direction: column; flex: 1; min-width: 0; }
.ws-trace-attachment-name {
  font-size: 12.5px; font-weight: 500; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
.ws-trace-attachment-size { font-size: 11px; color: var(--ws-ink-4); }
.ws-trace-attachment-thumb {
  width: 36px; height: 36px; border-radius: 7px;
  object-fit: cover; flex-shrink: 0;
  border: 1px solid var(--ws-line);
  background: var(--ws-soft);
}
.ws-trace-loading, .ws-trace-empty, .ws-trace-error {
  padding: 18px 20px; font-size: 13px; color: var(--ws-ink-4); text-align: center;
}
.ws-trace-error { color: var(--ws-err); }
.ws-trace-footer {
  display: flex; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-reply-footer {
  display: flex; flex-direction: column; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-reply-input {
  width: 100%; resize: vertical; min-height: 48px; max-height: 160px;
  padding: 10px 12px; border: 1px solid var(--ws-line-2); border-radius: var(--ws-r-sm);
  font-family: var(--ws-sans); font-size: 13px; line-height: 1.5;
  color: var(--ws-ink); background: var(--ws-panel);
  transition: border-color 0.15s;
}
.ws-trace-reply-input:focus {
  outline: none; border-color: var(--ws-ink-4);
}
.ws-trace-reply-input::placeholder { color: var(--ws-ink-5); }
.ws-trace-reply-input:disabled { opacity: 0.5; }
.ws-trace-reply-send { align-self: flex-end; }
.ws-trace-proposals {
  display: flex; flex-direction: column; gap: 8px;
  margin: 18px 0;
  padding: 14px 14px 12px;
  background: rgba(207, 140, 52, 0.06);
  border: 1px solid rgba(207, 140, 52, 0.28);
  border-radius: var(--ws-r-md);
}
.ws-trace-proposals .ws-trace-section-head {
  margin-bottom: 6px;
  color: var(--ws-warn, #cf8c34);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  display: flex; align-items: center; gap: 6px;
}
.ws-trace-proposals .ws-trace-section-head::before {
  content: "";
  display: inline-block;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ws-warn, #cf8c34);
  box-shadow: 0 0 0 3px rgba(207, 140, 52, 0.18);
}
.ws-trace-proposal-list {
  display: flex; flex-direction: column; gap: 0;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-panel);
  overflow: hidden;
}
.ws-prop-card {
  display: flex; flex-direction: column;
  background: var(--ws-panel);
  border-bottom: 1px solid var(--ws-line);
}
.ws-prop-card:last-child { border-bottom: 0; }

/* Small, square-ish buttons used in proposal cards.
   Selector is doubled to win the cascade against later .ws-btn rules
   defined elsewhere in this file. */
.ws-btn.ws-prop-mini-btn {
  padding: 4px 10px;
  font-size: 12px;
  gap: 5px;
  border-radius: var(--ws-r-sm);
  line-height: 1;
}
.ws-btn.ws-prop-icon-btn { padding: 4px 6px; }

.ws-prop-card--compact {
  display: flex; flex-direction: row; align-items: flex-start; gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.12s ease;
  position: relative;
}
.ws-prop-card--compact:hover { background: var(--ws-bg); }
.ws-prop-card--compact:focus-visible {
  outline: 2px solid var(--ws-line-2); outline-offset: -2px;
}
.ws-prop-card--compact > svg { margin-top: 1px; }
.ws-prop-card-summary {
  flex: 1 1 auto; min-width: 0;
  display: flex; flex-direction: column; gap: 4px;
}
.ws-prop-card-title-row {
  display: flex; align-items: center; gap: 10px;
  min-height: 24px;
}
.ws-prop-card-title {
  flex: 1 1 auto; min-width: 0;
  font-size: 13.5px; font-weight: 600; color: var(--ws-ink);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ws-prop-card-meta {
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
  font-size: 12.5px; color: var(--ws-ink-4);
}
.ws-prop-card-chip { display: inline; }
.ws-prop-card-chip + .ws-prop-card-chip::before {
  content: "·"; margin: 0 4px; color: var(--ws-ink-4);
}
.ws-prop-card-typepill {
  display: inline-flex; align-items: center;
  padding: 2px 8px; margin-left: 4px;
  background: var(--ws-soft); color: var(--ws-ink-3);
  border-radius: 999px; font-size: 11.5px; font-weight: 500;
  white-space: nowrap;
}
.ws-prop-card-status {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 2px 8px;
  border-radius: 999px; font-size: 11.5px; font-weight: 500;
  white-space: nowrap; flex-shrink: 0;
}
.ws-prop-card-status--pending { background: rgba(207,140,52,0.10); color: var(--ws-warn, #cf8c34); }
.ws-prop-card-status--saving  { background: rgba(60,109,182,0.10); color: var(--ws-info, #3c6db6); }
.ws-prop-card-status--ok      { background: rgba(47,122,78,0.10);  color: var(--ws-ok, #2f7a4e); }
.ws-prop-card-status--muted   { background: var(--ws-soft);        color: var(--ws-ink-4); }
.ws-prop-card-status--error   { background: rgba(178,52,52,0.10);  color: var(--ws-err, #b23434); }
.ws-prop-card-hover-actions {
  display: flex; gap: 6px; flex-shrink: 0;
  opacity: 0; transform: translateX(4px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  pointer-events: none;
}
.ws-prop-card--compact:hover .ws-prop-card-hover-actions,
.ws-prop-card--compact:focus-within .ws-prop-card-hover-actions {
  opacity: 1; transform: translateX(0);
  pointer-events: auto;
}

/* Expanded — tint + thicker bottom separator so it's easy to see
   where the active card ends when it sits in the list */
.ws-prop-card--expanded {
  background: var(--ws-bg);
  padding: 0;
  border-bottom-color: var(--ws-line-2);
}
.ws-prop-card-head {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 14px 8px;
  width: 100%;
  background: transparent; border: 0;
  font-family: inherit; text-align: left;
  cursor: pointer;
  transition: background 0.12s ease;
}
.ws-prop-card-head:hover { background: rgba(15, 30, 47, 0.025); }
.ws-prop-card-head .ws-prop-card-title { flex: 1 1 auto; }
.ws-prop-card-collapse {
  padding: 4px;
  border-radius: var(--ws-r-sm);
  color: var(--ws-ink-4);
  display: inline-flex; align-items: center; justify-content: center;
}
.ws-prop-card-head:hover .ws-prop-card-collapse { color: var(--ws-ink); }
.ws-prop-card-header-action { display: inline-flex; align-items: center; }
.ws-prop-card-header-action > * { pointer-events: auto; }
/* Section for an approval that has been resolved — full-bleed tinted band
 * across the drawer width so it reads as a distinct "done" state, mirroring
 * the amber pending band but in the ok-green tone. */
.ws-trace-resolved {
  display: flex; flex-direction: column; gap: 10px;
  /* Bleed past the .ws-trace-body horizontal padding (20px) to hit the
   * drawer edges. Vertical padding gives the card breathing room. */
  margin: 18px -20px;
  padding: 14px 20px 16px;
  background: rgba(47, 122, 78, 0.06);
  border-top: 1px solid rgba(47, 122, 78, 0.20);
  border-bottom: 1px solid rgba(47, 122, 78, 0.20);
}
.ws-trace-resolved-head {
  font-size: 12px; font-weight: 700;
  letter-spacing: 0.06em; text-transform: uppercase;
  color: var(--ws-ok, #2f7a4e);
  display: inline-flex; align-items: center; gap: 6px;
}
.ws-trace-resolved-head::before {
  content: "";
  display: inline-block;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ws-ok, #2f7a4e);
  box-shadow: 0 0 0 3px rgba(47, 122, 78, 0.16);
}
.ws-prop-card-body {
  padding: 4px 14px 12px;
}
.ws-prop-card-body .ws-trace-preview {
  border: 0;
  background: transparent;
  padding: 0;
}
.ws-prop-card-body .ws-trace-preview-headline { display: none; }
.ws-prop-card-note { padding: 0 14px 12px; }
.ws-prop-card-note-input {
  width: 100%;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 10px 12px;
  font-family: var(--ws-sans); font-size: 13px; color: var(--ws-ink);
  background: var(--ws-panel);
  resize: vertical;
  min-height: 70px;
}
.ws-prop-card-note-input:focus {
  outline: none; border-color: var(--ws-ink-3);
}
.ws-prop-card-actions {
  display: flex; gap: 6px; justify-content: flex-end;
  padding: 10px 14px;
  border-top: 1px solid var(--ws-line);
  background: var(--ws-panel);
}
.ws-trace-approval-footer {
  display: flex; flex-direction: column; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-approval-footer--failed {
  background: rgba(178,52,52,0.04);
}
.ws-trace-approval-failure {
  display: flex; align-items: center; gap: 8px;
  font-size: 12.5px; color: var(--ws-err); font-weight: 500;
}
.ws-trace-approval-toggle {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  width: 100%; padding: 10px 12px; border-radius: var(--ws-r-sm);
  background: rgba(47,122,78,0.05); border: 1px solid rgba(47,122,78,0.12);
  cursor: pointer; font-family: var(--ws-sans); text-align: left;
}
.ws-trace-approval-toggle:hover { background: rgba(47,122,78,0.08); }
.ws-trace-approval-label {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.04em; color: var(--ws-ok); margin-right: auto;
}
.ws-trace-approval-chips { display: flex; flex-wrap: wrap; gap: 5px; min-width: 0; flex: 1 1 100%; }
.ws-trace-approval-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 8px; border-radius: 999px; font-size: 11.5px; font-weight: 500;
  background: rgba(47,122,78,0.10); color: var(--ws-ok);
  white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis;
  min-width: 0;
}
.ws-trace-approval-detail-wrap {
  border: 1px solid var(--ws-line); border-radius: var(--ws-r-sm);
  overflow: hidden;
  padding: 12px;
  display: flex; flex-direction: column; gap: 12px;
  background: var(--ws-panel);
}
.ws-trace-approval-detail {
  margin: 0; font-size: 13px; line-height: 1.5; color: var(--ws-ink-1);
}
.ws-trace-approval-actions {
  display: flex; gap: 10px; flex-wrap: wrap;
  justify-content: flex-end;
}
.ws-trace-approval-header {
  display: flex; align-items: center;
  padding: 8px 4px;
}
.ws-trace-approval-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex; flex-direction: column; gap: 6px;
}
.ws-trace-approval-item {
  border: 1px solid rgba(47,122,78,0.16);
  border-radius: var(--ws-r-sm);
  background: rgba(47,122,78,0.04);
  overflow: hidden;
  transition: background 120ms ease;
}
.ws-trace-approval-item.is-open {
  background: var(--ws-panel);
}
.ws-trace-approval-row {
  width: 100%;
  display: flex; align-items: center; gap: 8px;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-family: var(--ws-sans);
  font-size: 12.5px;
  color: var(--ws-ink-1);
  transition: background 120ms ease;
  min-width: 0;
}
.ws-trace-approval-row:hover {
  background: rgba(47,122,78,0.08);
}
.ws-trace-approval-item.is-open .ws-trace-approval-row {
  border-bottom: 1px solid var(--ws-line);
}
.ws-trace-approval-row > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ws-trace-approval-item .ws-trace-approval-detail-wrap {
  border: none;
  border-radius: 0;
  background: var(--ws-panel);
}
.ws-trace-question-block {
  padding: 10px 12px; border-radius: var(--ws-r-sm);
  background: rgba(184,112,42,0.06); border: 1px solid rgba(184,112,42,0.12);
}
.ws-trace-question-text {
  margin: 0; font-size: 13px; line-height: 1.5; font-weight: 500;
  color: var(--ws-ink-1);
}
.ws-trace-question-options {
  display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;
}
.ws-trace-option-btn {
  background: var(--ws-panel) !important; border: 1px solid var(--ws-line-2) !important;
  font-weight: 500 !important;
}
.ws-trace-option-btn:hover:not(:disabled) {
  background: var(--ws-soft) !important; border-color: var(--ws-ink-4) !important;
}

/* Stats row */
.ws-trace-stats-row {
  display: grid; grid-template-columns: repeat(4, 1fr);
  gap: 1px; background: var(--ws-line);
  border: 1px solid var(--ws-line);
  border-radius: 8px; overflow: hidden;
  margin: 16px 0;
}
.ws-trace-stats-card {
  display: flex; align-items: baseline; gap: 8px;
  padding: 5px 12px;
  background: var(--ws-panel);
}
.ws-trace-stats-label {
  font-size: 10px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-4);
}
.ws-trace-stats-value {
  font-size: 13px; font-weight: 500;
  color: var(--ws-ink); font-variant-numeric: tabular-nums;
}

/* Activity trace */
.ws-trace-activity { margin-top: 18px; }
.ws-trace-activity-header {
  display: flex; align-items: center; justify-content: space-between;
  height: 28px; box-sizing: border-box;
  margin-bottom: 14px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-trace-expand-group {
  display: flex; align-items: center; gap: 4px; margin-left: auto;
}
.ws-trace-expand-toggle {
  display: inline-flex; align-items: center; gap: 4px;
  background: none; border: none; padding: 4px 8px; margin: 0;
  cursor: pointer; font-size: 11px; font-weight: 500;
  color: var(--ws-ink-3); border-radius: 5px;
  font-family: var(--ws-sans);
}
.ws-trace-expand-toggle:hover { color: var(--ws-ink); background: var(--ws-soft); }
.ws-trace-activity-scroll { overflow-y: auto; scrollbar-gutter: stable; }

/* Timeline steps */
.ws-trace-ev-list {
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column;
}
.ws-trace-step {
  display: grid; grid-template-columns: 22px 1fr; gap: 10px;
  padding: 8px 0;
  position: relative;
  animation: ws-slide-in 0.2s ease;
}
.ws-trace-step.is-queued { opacity: 0.55; }
.ws-trace-step.is-queued .ws-trace-label { color: var(--ws-ink-4); }
@keyframes ws-slide-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Rail: dot + connecting line */
.ws-trace-rail {
  position: relative;
  display: flex; flex-direction: column; align-items: center;
}
.ws-trace-dot {
  width: 22px; height: 22px; border-radius: 50%;
  background: var(--ws-panel);
  border: 1.5px solid var(--ws-ink-5);
  display: inline-flex; align-items: center; justify-content: center;
  color: var(--ws-ink-3);
  flex-shrink: 0;
  z-index: 1;
}
.ws-trace-dot svg { width: 9px; height: 9px; }
.ws-trace-dot--tool { background: var(--ws-panel); border-color: var(--ws-ink-3); color: var(--ws-ink-2); }
.ws-trace-dot--done { background: #E8F0EA; border-color: #8FB89A; color: #5A8C68; }
.ws-trace-dot--streaming {
  background: var(--ws-info); border-color: var(--ws-info); color: white;
  box-shadow: 0 0 0 3px rgba(59,107,168,0.2);
  animation: ws-dot-glow 1.4s infinite;
}
@keyframes ws-dot-glow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(59,107,168,0.4); }
  50% { box-shadow: 0 0 0 5px rgba(59,107,168,0); }
}
.ws-trace-dot--queued { border-style: dashed; opacity: 0.55; }
.ws-trace-dot--handoff { background: #C68A48; border-color: #C68A48; color: white; }
.ws-trace-dot--reasoning { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--spawn { background: var(--ws-ink); border-color: var(--ws-ink); color: white; }
.ws-trace-dot--error { background: var(--ws-err); border-color: var(--ws-err); color: white; }
.ws-trace-dot--approval { background: #D97706; border-color: #D97706; color: white; }
.ws-trace-dot--write { background: var(--ws-panel); border-color: var(--ws-info); color: var(--ws-info); }
.ws-trace-dot--thought { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--plan { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--plan-step { background: var(--ws-panel); border-color: var(--ws-ink-5); color: var(--ws-ink-3); }
.ws-trace-dot--plan-done { background: #E8F0EA; border-color: #8FB89A; color: #5A8C68; }
.ws-trace-dot--comment { background: var(--ws-panel); border-color: var(--ws-ink-4); color: var(--ws-ink-3); }

.ws-trace-step.is-plan-step { margin-left: 0; }
.ws-trace-step.is-group-child { padding: 2px 0; }
.ws-trace-step.is-group-child .ws-trace-dot { width: 16px; height: 16px; }
.ws-trace-step.is-group-child .ws-trace-dot svg { width: 7px; height: 7px; }
.ws-trace-step.is-group-child .ws-trace-head { font-size: 12px; }

.ws-trace-line {
  position: absolute;
  top: 22px; bottom: -8px;
  left: 50%; transform: translateX(-50%);
  width: 1.5px;
  background: var(--ws-line);
}
.ws-trace-step.is-streaming .ws-trace-line {
  background: linear-gradient(180deg, var(--ws-info), var(--ws-line) 80%);
}

/* Event body: head + label + detail */
.ws-trace-ev-body {
  min-width: 0; padding-top: 1px;
  display: flex; flex-direction: column; gap: 4px;
}
.ws-trace-head {
  display: flex; flex-wrap: nowrap; align-items: center; gap: 6px;
  font-size: 12.5px; min-width: 0;
}
.ws-trace-action { color: var(--ws-ink-3); white-space: nowrap; flex-shrink: 0; }
.ws-trace-system-label {
  font-size: 10px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.04em; color: var(--ws-ink-4);
  padding: 1px 6px; border-radius: 4px;
  background: var(--ws-soft); border: 1px solid var(--ws-line);
  flex-shrink: 0;
}
.ws-trace-actor-name { font-weight: 600; color: var(--ws-ink-2); font-size: 12.5px; white-space: nowrap; flex-shrink: 0; }
.ws-trace-head-label {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  min-width: 0; flex: 1; color: var(--ws-ink-2);
}
.ws-trace-tool-name {
  font-family: var(--ws-mono); font-size: 11.5px;
  background: var(--ws-soft); padding: 1px 5px; border-radius: 4px;
  color: var(--ws-ink-2);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  flex: none;
}
.ws-trace-meta {
  display: flex; align-items: center; gap: 6px;
  margin-left: auto; flex-shrink: 0;
}
.ws-trace-time {
  font-family: var(--ws-mono); font-size: 10.5px;
  color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
  white-space: nowrap; flex-shrink: 0;
}
.ws-trace-dur {
  font-family: var(--ws-mono); font-size: 10.5px;
  color: var(--ws-ink-4); font-variant-numeric: tabular-nums;
}

/* Status pill */
.ws-trace-pill {
  font-size: 9.5px; padding: 1px 6px; border-radius: 4px;
  font-weight: 500; white-space: nowrap;
  background: var(--ws-soft); color: var(--ws-ink-4);
  border: 1px solid var(--ws-line);
}
.ws-trace-pill--streaming {
  background: rgba(59,107,168,0.08); color: var(--ws-info);
  border-color: rgba(59,107,168,0.25);
}
.ws-trace-pill--ok {
  background: rgba(47,122,78,0.08); color: var(--ws-ok);
  border-color: rgba(47,122,78,0.25);
}
.ws-trace-pill--error {
  background: rgba(178,52,52,0.08); color: var(--ws-err);
  border-color: rgba(178,52,52,0.25);
}

/* Expand chevron */
/* Label (bigger text below head) */
.ws-trace-label {
  font-size: 13px; color: var(--ws-ink); font-weight: 500;
  margin-top: 2px; padding-right: 95px;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden;
}
.ws-trace-label.is-expandable,
.ws-trace-ev-detail.is-expandable { cursor: pointer; }
.ws-trace-ev-detail {
  font-size: 12px; color: var(--ws-ink-3); line-height: 1.5;
  padding-right: 95px;
}

/* Progress bar for streaming events */
.ws-trace-progress { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
.ws-trace-progress-track {
  flex: 1; height: 4px;
  background: var(--ws-soft); border-radius: 2px;
  overflow: hidden;
}
.ws-trace-progress-fill {
  display: block; height: 100%;
  background: var(--ws-info); border-radius: 2px;
  transition: width 300ms;
  animation: ws-progress-grow 3s ease-in-out infinite;
}
@keyframes ws-progress-grow {
  0% { width: 30%; }
  50% { width: 70%; }
  100% { width: 30%; }
}

/* IO block (expandable input/output) */
.ws-trace-io {
  margin-top: 8px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 7px;
  overflow: hidden;
}
.ws-trace-io-block { padding: 8px 10px; }
.ws-trace-io-block + .ws-trace-io-block { border-top: 1px dashed var(--ws-line); }
.ws-trace-io-key {
  font-size: 9.5px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
  margin-bottom: 3px;
}
.ws-trace-io-val {
  font-size: 11.5px; color: var(--ws-ink-2);
  line-height: 1.5; word-break: break-word; white-space: pre-wrap;
}
.ws-trace-io-mono {
  font-family: var(--ws-mono); font-size: 11px; color: var(--ws-ink);
}
.ws-trace-thought-full {
  font-size: 12.5px; line-height: 1.55; color: var(--ws-ink-2);
  white-space: pre-wrap; word-break: break-word;
  margin-top: 4px; padding: 8px 10px;
  background: var(--ws-soft); border-radius: var(--ws-r-sm);
}
.ws-trace-md { white-space: normal; word-break: break-word; }
.ws-trace-md p { margin: 0 0 6px; }
.ws-trace-md p:last-child { margin-bottom: 0; }
.ws-trace-md ul, .ws-trace-md ol { margin: 4px 0; padding-left: 20px; }
.ws-trace-md li { margin-bottom: 2px; }
.ws-trace-md strong, .ws-trace-md b { font-weight: 600; color: var(--ws-ink); }
.ws-trace-md em, .ws-trace-md i { font-style: italic; }
.ws-trace-md a { color: var(--ws-accent, #2962ff); text-decoration: underline; }
.ws-trace-md code { font-family: var(--ws-mono); font-size: 11.5px; background: var(--ws-line); padding: 1px 4px; border-radius: 3px; }
.ws-trace-md h1, .ws-trace-md h2, .ws-trace-md h3, .ws-trace-md h4, .ws-trace-md h5, .ws-trace-md h6 {
  margin: 14px 0 6px; font-weight: 600; color: var(--ws-ink); line-height: 1.3;
}
.ws-trace-md h1:first-child, .ws-trace-md h2:first-child, .ws-trace-md h3:first-child,
.ws-trace-md h4:first-child, .ws-trace-md h5:first-child, .ws-trace-md h6:first-child { margin-top: 0; }
.ws-trace-md h1 { font-size: 16px; }
.ws-trace-md h2 { font-size: 15px; }
.ws-trace-md h3 { font-size: 13.5px; }
.ws-trace-md h4, .ws-trace-md h5, .ws-trace-md h6 { font-size: 13px; }
.ws-trace-md hr { border: 0; border-top: 1px solid var(--ws-line); margin: 12px 0; }
.ws-trace-md blockquote {
  margin: 6px 0; padding: 4px 10px; color: var(--ws-ink-3);
  border-left: 2px solid var(--ws-line); background: var(--ws-soft);
}
.ws-trace-md pre {
  margin: 6px 0; padding: 8px 10px; background: var(--ws-line);
  border-radius: var(--ws-r-sm); overflow-x: auto;
  font-family: var(--ws-mono); font-size: 11.5px; line-height: 1.5;
}
.ws-trace-md pre code { background: transparent; padding: 0; font-size: inherit; }
.ws-trace-md table {
  border-collapse: collapse; margin: 8px 0; font-size: 12.5px;
  display: block; max-width: 100%; overflow-x: auto;
}
.ws-trace-md th, .ws-trace-md td {
  border: 1px solid var(--ws-line); padding: 5px 8px; text-align: left; vertical-align: top;
}
.ws-trace-md th { background: var(--ws-soft); font-weight: 600; color: var(--ws-ink); }

/* Plan section (standalone, always visible) */
.ws-trace-plan-section {
  margin-bottom: 16px;
}
.ws-trace-plan-checklist {
  display: flex; flex-direction: column;
  border: 1px solid var(--ws-line); border-radius: 7px;
  overflow: hidden;
}
.ws-trace-plan-check-row {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px;
  border-bottom: 1px solid var(--ws-line);
  font-size: 12.5px; color: var(--ws-ink-4);
  filter: blur(2.5px); user-select: none;
  transition: filter 0.3s, color 0.3s;
}
.ws-trace-plan-check-row:last-child { border-bottom: 0; }
.ws-trace-plan-check-row.is-done {
  filter: none; color: var(--ws-ink-2); user-select: auto;
}
.ws-trace-plan-check-icon {
  width: 16px; height: 16px; border-radius: 50%;
  border: 1.5px solid var(--ws-ink-5);
  background: var(--ws-panel);
  display: grid; place-items: center;
  flex-shrink: 0;
}
.ws-trace-plan-check-icon.done {
  background: var(--ws-ok); border-color: var(--ws-ok); color: white;
}
.ws-trace-plan-check-title { flex: 1; font-weight: 500; min-width: 0; }

/* Live banner */
.ws-trace-live-banner {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px; margin-top: 4px;
  background: rgba(59,107,168,0.06);
  border: 1px dashed rgba(59,107,168,0.3);
  border-radius: var(--ws-r-md);
  font-size: 11.5px; color: var(--ws-ink-3);
}

.ws-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: var(--ws-r-sm);
  font-size: 13px; font-weight: 500; cursor: pointer;
  border: 1px solid var(--ws-line); background: var(--ws-panel);
  color: var(--ws-ink); transition: background 0.12s, border-color 0.12s;
}
.ws-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.ws-btn-sm { padding: 5px 10px; font-size: 12px; }
.ws-btn-primary { background: var(--ws-ink); color: var(--ws-bg); border-color: var(--ws-ink); }
.ws-btn-primary:hover:not(:disabled) { background: #244856; }
.ws-btn-secondary { background: var(--ws-panel); }
.ws-btn-secondary:hover:not(:disabled) { background: var(--ws-hover); }
.ws-btn-danger { background: var(--ws-err); color: var(--ws-bg); border-color: var(--ws-err); }
.ws-btn-danger:hover:not(:disabled) { background: #a04438; }
.ws-btn-ghost { background: transparent; border-color: transparent; }
.ws-btn-ghost:hover:not(:disabled) { background: var(--ws-hover); }

/* ===== Command home additions ===== */
.ws-cmd-section { max-width: 880px; width: 100%; margin: 0 auto 18px; padding: 0 4px; }
.ws-cmd-section-head {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-4); margin: 0 0 10px;
}
.ws-cmd-section-link {
  background: transparent; border: 0; padding: 0; cursor: pointer;
  font-size: 11px; color: var(--ws-ink-3); text-decoration: underline;
}
.ws-cmd-needs-you { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 10px; }
.ws-cmd-needs-card {
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); padding: 12px; cursor: pointer;
  text-align: left;
}
.ws-cmd-needs-card:hover { background: var(--ws-hover); }
.ws-cmd-needs-card-head {
  font-size: 11px; font-weight: 600; color: var(--ws-warn);
  text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px;
}
.ws-cmd-needs-card-title { font-size: 13.5px; line-height: 1.4; color: var(--ws-ink); }
.ws-cmd-progress-row {
  display: flex; align-items: center; gap: 10px;
  padding: 8px; border-bottom: 1px solid var(--ws-line); cursor: pointer;
}
.ws-cmd-progress-row:hover { background: var(--ws-hover); }
.ws-cmd-progress-spinner {
  width: 12px; height: 12px; border-radius: 50%;
  border: 2px solid var(--ws-line-2);
  border-top-color: var(--ws-info);
  animation: ws-spin 0.9s linear infinite;
  flex-shrink: 0;
}
@keyframes ws-spin { to { transform: rotate(360deg); } }
.ws-cmd-progress-meta { font-size: 12px; color: var(--ws-ink-4); }
.ws-cmd-recent-row {
  display: grid; grid-template-columns: 1fr auto auto;
  align-items: center; gap: 10px; padding: 8px;
  border-bottom: 1px solid var(--ws-line); cursor: pointer;
}
.ws-cmd-recent-row:hover { background: var(--ws-hover); }
.ws-cmd-recent-events {
  background: var(--ws-soft); border-radius: var(--ws-r-sm);
  padding: 12px; margin: 0 0 8px;
}
.ws-cmd-continue-link {
  display: inline-flex; align-items: center; gap: 6px;
  background: transparent; border: 0; padding: 4px 0;
  font-size: 12px; font-weight: 450; letter-spacing: 0; text-transform: none;
  color: var(--ws-ink-3); cursor: pointer;
  text-decoration: underline;
}
.ws-cmd-continue-link:hover { color: var(--ws-ink); }

/* ===== Slash command picker ===== */
.ws-slash-picker {
  position: absolute; bottom: calc(100% + 6px); left: 0; right: 0;
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); box-shadow: var(--ws-shadow-md);
  z-index: 30; overflow: hidden;
}
.ws-slash-item {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 12px; font-size: 13px; cursor: pointer;
  border-bottom: 1px solid var(--ws-line);
}
.ws-slash-item:last-child { border-bottom: 0; }
.ws-slash-item.active { background: var(--ws-hover); }
.ws-slash-cmd {
  font-family: var(--ws-mono); font-size: 12px;
  color: var(--ws-ink-3); background: var(--ws-soft);
  padding: 1px 6px; border-radius: 3px;
}
.ws-slash-desc { color: var(--ws-ink-3); }

/* ===== Agent edit form ===== */
.ws-agent-edit-input, .ws-agent-edit-textarea, .ws-agent-edit-select {
  width: 100%; border: 1px solid var(--ws-line); border-radius: var(--ws-r-sm);
  padding: 8px 10px; font-size: 13.5px; background: var(--ws-panel);
  color: var(--ws-ink); font-family: inherit;
}
.ws-agent-edit-textarea { min-height: 96px; resize: vertical; line-height: 1.5; }
.ws-agent-save-bar {
  position: sticky; bottom: 0; background: var(--ws-panel);
  border-top: 1px solid var(--ws-line);
  padding: 12px 24px; display: flex; gap: 10px; justify-content: flex-end;
}

/* ===== Promote to org ===== */
.ws-promote-wrap {
  position: relative; display: inline-flex;
}
.ws-promote-wrap:hover .ws-promote-tooltip { opacity: 1; pointer-events: auto; }
.ws-promote-tooltip {
  position: absolute; top: 100%; left: 0; margin-top: 6px;
  background: var(--ws-ink); color: white; font-size: 11.5px; line-height: 1.5;
  padding: 8px 12px; border-radius: 8px; width: 260px;
  opacity: 0; pointer-events: none; transition: opacity 0.15s;
  z-index: 10;
}
.ws-modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.ws-promote-modal {
  background: var(--ws-panel); border-radius: 14px; width: 480px; max-width: 90vw;
  box-shadow: 0 24px 48px rgba(0,0,0,0.15); overflow: hidden;
}
.ws-promote-modal-head {
  display: flex; align-items: center; gap: 10px;
  padding: 20px 24px 0; color: var(--ws-ink);
}
.ws-promote-modal-head h2 {
  flex: 1; font-size: 16px; font-weight: 600; margin: 0;
}
.ws-promote-stats {
  padding: 18px 24px; display: flex; flex-direction: column; gap: 14px;
}
.ws-promote-stat-label {
  font-size: 12px; color: var(--ws-ink-3); margin-bottom: 5px; font-weight: 500;
}
.ws-promote-stat-row {
  display: flex; align-items: center; gap: 12px;
}
.ws-promote-bar {
  flex: 1; height: 6px; background: var(--ws-line); border-radius: 3px; overflow: hidden;
}
.ws-promote-bar-fill {
  height: 100%; border-radius: 3px; background: var(--ws-ink-4);
  transition: width 0.3s ease;
}
.ws-promote-bar-fill.ok { background: var(--ws-ok, #2F7A4E); }
.ws-promote-stat-num {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-2);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.ws-promote-pitch {
  padding: 0 24px 18px;
}
.ws-promote-pitch-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 600; color: var(--ws-ink-2); margin-bottom: 8px;
}
.ws-promote-textarea {
  width: 100%; border: 1px solid var(--ws-line); border-radius: 8px;
  padding: 12px; font-size: 13px; line-height: 1.55;
  resize: vertical; min-height: 80px; background: var(--ws-surface);
  color: var(--ws-ink); font-family: var(--ws-sans);
}
.ws-promote-textarea:focus { outline: none; border-color: var(--ws-ink-4); }
.ws-promote-pitch-hint {
  font-size: 11.5px; color: var(--ws-ink-4); margin-top: 6px;
}
.ws-promote-error {
  padding: 0 24px; font-size: 12px; color: var(--ws-err);
}
.ws-promote-actions {
  display: flex; gap: 10px; justify-content: flex-end;
  padding: 16px 24px; border-top: 1px solid var(--ws-line);
}

/* ===== Promotion progress (inline on Identity tab) ===== */
.ws-promo-progress {
  margin-top: 20px; padding: 16px;
  background: var(--ws-soft); border-radius: var(--ws-r-md);
}
.ws-promo-progress-header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 14px;
}
.ws-promo-progress-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 600; color: var(--ws-ink-2);
  margin: 0;
}
.ws-promo-progress-row { margin-bottom: 12px; }
.ws-promo-progress-row:last-of-type { margin-bottom: 0; }
.ws-promo-progress-label {
  font-size: 12px; color: var(--ws-ink-3); margin-bottom: 5px; font-weight: 500;
}
.ws-promo-progress-bar-row { display: flex; align-items: center; gap: 12px; }
.ws-promo-progress-pending {
  font-size: 12px; color: var(--ws-warn); margin-top: 10px; font-weight: 500;
}

/* ===== Org chart "+" button ===== */
.ws-org-add-btn {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  margin-top: 8px; width: 100%; padding: 8px 12px;
  border: 1px dashed var(--ws-line-2); background: transparent;
  color: var(--ws-ink-3); border-radius: var(--ws-r-md);
  font-size: 12px; cursor: pointer; transition: background 0.12s, border-color 0.12s;
}
.ws-org-add-btn:hover { background: var(--ws-hover); border-color: var(--ws-ink-4); color: var(--ws-ink); }
.ws-org-card.ws-org-drop-hint {
  border-style: dashed;
  border-color: rgba(47,122,78,0.35);
}
.ws-org-card.ws-org-drop-target {
  border-color: #2F7A4E;
  border-style: solid;
  background: rgba(47,122,78,0.04);
  box-shadow: 0 0 0 2px rgba(47,122,78,0.12);
}
.ws-org-card.ws-org-dragging {
  opacity: 0.35; pointer-events: none;
}
.ws-org-card[draggable="true"] { cursor: grab; }
.ws-org-card[draggable="true"]:active { cursor: grabbing; }
.ws-org-card.ws-org-card-add {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
  border: 1.5px dashed var(--ws-line-2); background: transparent;
  color: var(--ws-ink-3); cursor: pointer;
  align-self: stretch;
  transition: background 0.12s, border-color 0.12s, color 0.12s;
}
.ws-org-card.ws-org-card-add:hover { background: var(--ws-hover); border-color: var(--ws-ink-4); color: var(--ws-ink); }
.ws-org-card.ws-org-card-add span { font-size: 12px; }

/* ===== Admin view ===== */
.ws-admin-period-nav {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ws-admin-period-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--ws-ink-2);
  min-width: 120px;
  text-align: center;
  user-select: none;
}
.ws-admin-month-input {
  font-family: var(--ws-sans);
  font-size: 13px;
  font-weight: 500;
  color: var(--ws-ink-2);
  background: transparent;
  border: none;
  text-align: center;
  cursor: pointer;
  min-width: 130px;
  padding: 4px 0;
}
.ws-admin-month-input::-webkit-calendar-picker-indicator { cursor: pointer; opacity: 0.5; }
.ws-admin-month-input:focus { outline: none; color: var(--ws-ink); }
.ws-btn-icon {
  padding: 5px 6px;
  line-height: 1;
}
.ws-btn-icon:disabled { opacity: 0.3; cursor: not-allowed; }

.ws-admin-body {
  padding: 0 32px 80px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
  box-sizing: border-box;
}
.ws-admin-state {
  display: flex; align-items: center; gap: 8px;
  padding: 28px 0;
  font-size: 13px;
  color: var(--ws-ink-4);
}
.ws-admin-state-err { color: var(--ws-err); }

/* ===== Settings: sidebar takeover (Linear-style) =====
   While route === 'settings' the workspace sidebar is swapped for this rail,
   reusing the sidebar's own visual language (ws-sb-item / ws-sb-section-label)
   so it reads as the same surface, never as a third menu. */
.ws-settings-sidebar .ws-sb-scrollable {
  padding-top: 14px;
}
.ws-settings-back {
  color: var(--ws-ink-3);
  margin-bottom: 4px;
}
.ws-settings-nav {
  display: flex;
  flex-direction: column;
}
.ws-settings-nav-group {
  margin-top: 14px;
}
/* Body content: consistent breathing room below the topbar — every tab gets
   the same gap the Skills card used to carry as its own margin. */
.ws-settings-body {
  padding-top: 24px;
}

/* Usage pane toolbar — scope toggle + period nav share one row. */
.ws-usage-pane-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}
.ws-usage-pane-toolbar .ws-admin-period-nav { margin-left: 0; }

/* Segmented scope toggle (You / Organisation), reused on the org page. */
.ws-scope-toggle {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  background: var(--ws-hover);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
}
.ws-scope-toggle-btn {
  padding: 5px 14px;
  border: 0;
  background: transparent;
  border-radius: 6px;
  font-family: var(--ws-sans);
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ws-ink-4);
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.ws-scope-toggle-btn:hover { color: var(--ws-ink-2); }
.ws-scope-toggle-btn.is-active {
  background: white;
  color: var(--ws-ink);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.ws-admin-card {
  background: white;
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 18px;
}
.ws-admin-card-head {
  /* Row layout: title left, header actions (buttons/toggles) right — Skills, Connections,
     Slack and Users all rely on this. */
  display: flex; align-items: baseline; justify-content: space-between; gap: 12px;
  margin-bottom: 14px;
}
.ws-admin-card-head--stacked {
  /* Variant for cards whose head is title + descriptive text only: stack the description
     under the title instead of flinging it to the far right of the card. */
  flex-direction: column; align-items: flex-start; gap: 2px;
}
.ws-admin-card-head h3 {
  margin: 0;
  font-size: 14px; font-weight: 600;
  color: var(--ws-ink);
}
.ws-admin-card .ws-sub { font-size: 12px; color: var(--ws-ink-4); }
.ws-admin-empty {
  padding: 22px 4px;
  font-size: 13px;
  color: var(--ws-ink-4);
  text-align: center;
}

/* Hero */
.ws-admin-hero {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 28px;
  align-items: center;
  background: white;
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  padding: 22px 24px;
  margin-bottom: 18px;
}
.ah-side .ah-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--ws-ink-4); font-weight: 600;
}
.ah-side .ah-value {
  font-family: var(--ws-serif);
  font-size: 44px; font-weight: 600; letter-spacing: -0.01em;
  color: var(--ws-ink);
  margin-top: 4px; line-height: 1;
}
.ah-side .ah-of { font-size: 13px; color: var(--ws-ink-4); margin-top: 6px; }
.ah-bar {
  margin-top: 14px;
  height: 4px;
  background: var(--ws-line);
  border-radius: 999px;
  overflow: hidden;
}
.ah-bar-fill {
  height: 100%;
  background: var(--ws-ink);
}

/* Credit-pool hero styling — same scaffold, status-coloured fill so a
   glance tells you whether the account is over, near, or under cap. */
.ws-credit-hero { background: var(--ws-panel); }
.ws-credit-bar-fill--ok { background: var(--ws-ok, #2f7a4e); }
.ws-credit-bar-fill--warn { background: var(--ws-warn, #cf8c34); }
.ws-credit-bar-fill--over { background: var(--ws-err, #b23434); }

/* Soft-warn banner — informational, never blocks the agent. */
.ws-credit-warn {
  display: flex; align-items: center; gap: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid;
  margin-bottom: 14px;
  font-size: 13px;
}
.ws-credit-warn--warn {
  background: rgba(207, 140, 52, 0.08);
  border-color: rgba(207, 140, 52, 0.30);
  color: var(--ws-warn, #cf8c34);
}
.ws-credit-warn--over {
  background: rgba(178, 52, 52, 0.06);
  border-color: rgba(178, 52, 52, 0.28);
  color: var(--ws-err, #b23434);
}
.ws-credit-warn-text { flex: 1; }
.ws-credit-warn-cta {
  font-size: 12px; font-weight: 600;
  padding: 6px 12px; border-radius: 4px;
  border: 1px solid currentColor;
  background: transparent; color: inherit;
  cursor: pointer;
}
.ws-credit-warn-cta:hover { background: currentColor; color: var(--ws-panel); }

/* Per-tool breakdown — one row per feature, sorted server-side by
   creditsSek desc, bar normalised against the heaviest tool. */
.ws-credit-tools { display: flex; flex-direction: column; gap: 8px; }
.ws-credit-tool-row {
  display: grid;
  grid-template-columns: minmax(140px, 1.5fr) 3fr auto;
  align-items: center;
  gap: 14px;
  padding: 6px 0;
}
.ws-credit-tool-name {
  font-family: 'SF Mono', Menlo, monospace;
  font-size: 12px;
  color: var(--ws-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ws-credit-tool-bar {
  height: 8px;
  background: var(--ws-line);
  border-radius: 999px;
  overflow: hidden;
}
.ws-credit-tool-fill {
  height: 100%;
  background: var(--ws-ink);
  border-radius: 999px;
}
.ws-credit-tool-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  min-width: 90px;
}
.ws-credit-tool-credits { font-weight: 600; color: var(--ws-ink); }
.ws-credit-tool-calls { color: var(--ws-ink-5); font-size: 11px; }

/* Admin Usage breakdown — list view with group-by selector + filter. */
.ws-usage-toolbar {
  display: flex; align-items: center; gap: 12px;
  flex-wrap: wrap;
}
.ws-usage-groupby {
  display: inline-flex;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 6px;
  padding: 2px;
}
.ws-usage-groupby-btn {
  border: 0;
  background: transparent;
  padding: 4px 12px;
  font-size: 12.5px;
  color: var(--ws-ink-3);
  cursor: pointer;
  border-radius: 4px;
}
.ws-usage-groupby-btn:hover { color: var(--ws-ink); }
.ws-usage-groupby-btn.is-active {
  background: var(--ws-panel);
  color: var(--ws-ink);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 30, 47, 0.06);
}
.ws-usage-filter {
  flex: 1;
  min-width: 180px;
  padding: 6px 10px;
  border: 1px solid var(--ws-line);
  border-radius: 6px;
  font-size: 13px;
}
.ws-usage-filter:focus { outline: none; border-color: var(--ws-ink-3); }

.ws-usage-list { display: flex; flex-direction: column; gap: 6px; }
.ws-usage-row {
  padding: 8px 0;
  border-bottom: 1px solid var(--ws-line);
}
.ws-usage-row:last-child { border-bottom: 0; }
.ws-usage-row.is-clickable { cursor: pointer; }
.ws-usage-row.is-clickable:hover { background: rgba(15, 30, 47, 0.02); }
.ws-usage-row-main {
  display: grid;
  grid-template-columns: minmax(160px, 1.6fr) 3fr auto;
  align-items: center;
  gap: 14px;
}
.ws-usage-row-label { min-width: 0; }
.ws-usage-row-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--ws-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ws-usage-row-coverage-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--ws-ink-4);
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 999px;
  text-transform: uppercase;
}
.ws-usage-row-sub {
  font-size: 11.5px;
  color: var(--ws-ink-5);
  margin-top: 2px;
}
.ws-usage-row-bar {
  height: 8px;
  background: var(--ws-line);
  border-radius: 999px;
  overflow: hidden;
}
.ws-usage-row-bar-fill {
  height: 100%;
  background: var(--ws-ink);
  border-radius: 999px;
}
.ws-usage-row-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-variant-numeric: tabular-nums;
  font-size: 12.5px;
  min-width: 110px;
}
.ws-usage-row-credits { font-weight: 600; color: var(--ws-ink); }
.ws-usage-row-calls { color: var(--ws-ink-5); font-size: 11px; }
.ws-usage-row-detail {
  padding: 8px 0 4px 0;
  font-size: 12.5px;
  color: var(--ws-ink-4);
  line-height: 1.5;
}

/* Category expansion — list of constituent features under a category row. */
.ws-usage-row-details {
  padding: 8px 0 4px 16px;
  display: flex; flex-direction: column; gap: 6px;
  border-left: 2px solid var(--ws-line);
  margin-left: 6px;
}
.ws-usage-row-detail-row {
  display: flex; justify-content: space-between; align-items: flex-start;
  gap: 12px;
  font-size: 12.5px;
}
.ws-usage-row-detail-label { min-width: 0; }
.ws-usage-row-detail-name { font-weight: 500; color: var(--ws-ink-2); }
.ws-usage-row-detail-desc { font-size: 11.5px; color: var(--ws-ink-5); margin-top: 2px; }
.ws-usage-row-detail-meta {
  display: flex; flex-direction: column; align-items: flex-end;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  min-width: 90px;
}

/* Daily bar chart */
.ws-usage-chart {
  display: flex; flex-direction: column; gap: 6px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: 6px;
  padding: 10px 12px;
}
.ws-usage-chart-svg {
  width: 100%;
  height: 80px;
  display: block;
}
.ws-usage-chart-bar {
  fill: oklch(0.60 0.13 250);
  fill-opacity: 0.78;
  transition: fill-opacity 0.12s, fill 0.12s;
  cursor: pointer;
}
.ws-usage-chart-bar.is-hover,
.ws-usage-chart-bar:hover { fill: oklch(0.50 0.16 250); fill-opacity: 1; }
.ws-usage-chart-meta {
  font-size: 12px;
  color: var(--ws-ink);
  min-height: 16px;
}
.ws-usage-chart-empty {
  padding: 24px;
  text-align: center;
  color: var(--ws-ink-5);
  font-size: 13px;
  border: 1px dashed var(--ws-line);
  border-radius: 6px;
}
.ws-usage-chart.is-loading {
  opacity: 0.55;
  transition: opacity 0.2s;
}

/* Expandable filter panel below the toolbar */
.ws-usage-filter-panel {
  display: flex; flex-direction: column; gap: 8px;
  padding: 10px 0 0 0;
  border-top: 1px dashed var(--ws-line);
  margin-top: 4px;
}

/* Multiselect popover (Users / Agents) */
.ws-usage-multiselect-trigger {
  display: inline-flex; align-items: center; gap: 6px;
}
.ws-usage-multiselect-popover {
  width: 280px;
  padding: 8px;
  display: flex; flex-direction: column; gap: 6px;
}
.ws-usage-multiselect-search {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid var(--ws-line);
  border-radius: 4px;
  font-size: 12.5px;
}
.ws-usage-multiselect-search:focus { outline: none; border-color: var(--ws-ink-3); }
.ws-usage-multiselect-list {
  display: flex; flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
  gap: 0;
}
.ws-usage-multiselect-empty {
  padding: 12px;
  font-size: 12px;
  color: var(--ws-ink-5);
  text-align: center;
}
.ws-usage-multiselect-item {
  display: flex; align-items: flex-start; gap: 8px;
  width: 100%;
  padding: 6px 8px;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  border-radius: 4px;
}
.ws-usage-multiselect-item:hover { background: var(--ws-soft); }
.ws-usage-multiselect-item.is-checked { background: rgba(15, 30, 47, 0.04); }
.ws-usage-multiselect-check {
  display: inline-flex; align-items: center; justify-content: center;
  width: 16px; height: 16px;
  border: 1px solid var(--ws-line);
  border-radius: 3px;
  background: var(--ws-panel);
  margin-top: 1px;
  flex-shrink: 0;
}
.ws-usage-multiselect-item.is-checked .ws-usage-multiselect-check {
  background: var(--ws-ink);
  border-color: var(--ws-ink);
  color: var(--ws-panel);
}
.ws-usage-multiselect-label { display: flex; flex-direction: column; min-width: 0; }
.ws-usage-multiselect-name { font-size: 12.5px; color: var(--ws-ink); }
.ws-usage-multiselect-sub { font-size: 11px; color: var(--ws-ink-5); }
.ws-usage-multiselect-clear {
  border: 0;
  background: transparent;
  color: var(--ws-ink-4);
  font-size: 11.5px;
  cursor: pointer;
  text-align: left;
  padding: 4px 8px;
}
.ws-usage-multiselect-clear:hover { color: var(--ws-ink); }

/* Collapse-LLM toggle */
.ws-usage-collapse-toggle {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; color: var(--ws-ink-3);
  cursor: pointer;
  margin-left: auto;
}
.ws-usage-collapse-toggle input { margin: 0; cursor: pointer; }
.ah-bar-meta {
  margin-top: 8px;
  font-size: 12px;
  color: var(--ws-ink-4);
  display: flex; gap: 8px;
}
.ah-spark { min-width: 0; }

/* KPI strip */
.ws-admin-kpis {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 18px;
}
.ws-admin-kpis .kpi {
  background: white;
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.kpi-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--ws-ink-4); font-weight: 600;
}
.kpi-value-row { display: flex; align-items: center; gap: 8px; margin-top: 6px; min-width: 0; }
.kpi-value {
  font-family: var(--ws-serif);
  font-size: 26px; font-weight: 600;
  color: var(--ws-ink);
  line-height: 1;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.kpi-value.ok { color: var(--ws-ok); }
.kpi-value.warn { color: var(--ws-warn); }
.kpi-value.err { color: var(--ws-err); }
.kpi-sub { font-size: 11.5px; color: var(--ws-ink-4); margin-top: 4px; }
.ws-admin-kpis .kpi.is-clickable { cursor: pointer; transition: border-color 0.12s, box-shadow 0.12s; }
.ws-admin-kpis .kpi.is-clickable:hover {
  border-color: var(--ws-ink-4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* Two-column grid */
.ws-admin-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.ws-admin-list {
  display: flex; flex-direction: column;
  gap: 10px;
}
/* "Show more / show less" expander under capped overview lists */
.ws-admin-list-more {
  border: 0; background: none;
  padding: 8px 4px 2px;
  font-size: 12px; font-weight: 500;
  color: var(--ws-ink-4);
  cursor: pointer;
  text-align: center;
}
.ws-admin-list-more:hover { color: var(--ws-ink); }

/* User spend rows */
.user-spend-row,
.agent-usage-row {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 4px;
  border-bottom: 1px solid var(--ws-line);
}
.user-spend-row:last-child,
.agent-usage-row:last-child { border-bottom: 0; }
.user-spend-row.is-clickable,
.agent-usage-row.is-clickable { cursor: pointer; border-radius: 8px; }
.user-spend-row.is-clickable:hover,
.agent-usage-row.is-clickable:hover { background: var(--ws-soft); }
.usr-avatar {
  width: 32px; height: 32px;
  border-radius: 999px;
  display: grid; place-items: center;
  font-family: var(--ws-serif);
  font-size: 12px; font-weight: 700;
  color: white;
  flex-shrink: 0;
}
.usr-name { font-weight: 500; color: var(--ws-ink); font-size: 13px; }
.usr-role { font-size: 11.5px; color: var(--ws-ink-4); }
.usr-bars { display: flex; flex-direction: column; gap: 4px; min-width: 220px; }
.usr-bar-row { display: flex; align-items: center; gap: 8px; font-size: 11.5px; }
.usr-bar-label { color: var(--ws-ink-4); width: 80px; flex-shrink: 0; }
.usr-bar {
  flex: 1; height: 4px;
  background: var(--ws-line);
  border-radius: 999px;
  overflow: hidden;
}
.usr-bar-fill { height: 100%; }
.usr-bar-val {
  font-variant-numeric: tabular-nums;
  font-size: 11.5px; color: var(--ws-ink-3);
  width: 110px; text-align: right;
}
.usr-total {
  font-family: var(--ws-serif);
  font-size: 18px; font-weight: 600;
  color: var(--ws-ink);
  font-variant-numeric: tabular-nums;
  width: 80px; text-align: right;
}

/* Success badges */
.success-badge {
  width: 64px; flex-shrink: 0;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  background: var(--ws-soft);
}
.success-badge.ok { color: var(--ws-ok); background: rgba(47,122,78,0.08); }
.success-badge.warn { color: var(--ws-warn); background: rgba(184,112,42,0.08); }
.success-badge.err { color: var(--ws-err); background: rgba(184,74,62,0.08); }
.success-badge .sb-num { font-family: var(--ws-serif); font-size: 16px; font-weight: 700; line-height: 1; }
.success-badge .sb-lbl { font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em; opacity: 0.85; }

/* Pills used in admin */
.ws-pill {
  display: inline-flex; align-items: center;
  font-size: 10.5px; font-weight: 600; letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
  border: 1px solid var(--ws-line);
}
.ws-pill.dark {
  background: var(--ws-ink); color: #e8f9f8; border-color: var(--ws-ink);
}
.ws-pill.warn {
  background: rgba(184,112,42,0.12); color: var(--ws-warn); border-color: rgba(184,112,42,0.25);
}

/* Tables */
.ws-admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.ws-admin-table th {
  text-align: left;
  padding: 8px 10px;
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em;
  font-weight: 600; color: var(--ws-ink-4);
  border-bottom: 1px solid var(--ws-line);
}
.ws-admin-table td {
  padding: 12px 10px;
  border-bottom: 1px solid var(--ws-line);
  vertical-align: middle;
  color: var(--ws-ink-2);
}
.ws-admin-table tr:last-child td { border-bottom: 0; }

/* WEB-7089 — runs audit table */
.ws-runs-row.is-clickable { cursor: pointer; }
.ws-runs-row.is-clickable:hover td { background: var(--ws-soft); }
.ws-runs-date {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--ws-ink-4);
}
.ws-runs-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 10px 0;
}

/* Promotion cards */
.ws-promotion-card {
  background: linear-gradient(180deg, white, var(--ws-soft));
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  padding: 18px 20px;
}
.ws-promotion-head { display: flex; align-items: center; gap: 12px; }
.ws-promotion-name { font-weight: 600; color: var(--ws-ink); font-size: 14px; }
.ws-promotion-quote {
  margin: 12px 0 0;
  padding: 10px 14px;
  font-family: var(--ws-serif);
  font-style: italic;
  font-size: 14px;
  color: var(--ws-ink-2);
  border-left: 2px solid var(--ws-ink);
  background: white;
  border-radius: 0 6px 6px 0;
}
.ws-promotion-stats {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.ws-promotion-stats .ps-num {
  font-family: var(--ws-serif);
  font-size: 18px; font-weight: 600;
  color: var(--ws-ink);
  font-variant-numeric: tabular-nums;
}
.ws-promotion-stats .ps-lbl {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--ws-ink-4);
  margin-top: 2px;
}
.ws-promotion-actions {
  margin-top: 14px;
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Promotion threshold config */
.ws-admin-threshold-row {
  display: flex; gap: 16px; align-items: flex-end;
  padding: 0 20px 20px;
}
.ws-admin-threshold-field {
  display: flex; flex-direction: column; gap: 5px; flex: 1;
}
.ws-admin-threshold-field label {
  font-size: 12px; font-weight: 500; color: var(--ws-ink-3);
}

/* Limits grid */
.ws-admin-limits-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.ws-admin-limit-card {
  padding: 16px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 8px;
}
.ws-admin-limit-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--ws-ink-4); font-weight: 600;
}
.ws-admin-limit-input-row {
  display: flex; align-items: center; gap: 4px; margin-top: 4px;
}
.ws-admin-limit-dollar {
  font-family: var(--ws-serif); font-size: 20px; font-weight: 600; color: var(--ws-ink-3);
}
.ws-admin-limit-input {
  font-family: var(--ws-serif); font-size: 20px; font-weight: 600; color: var(--ws-ink);
  background: var(--ws-bg); border: 1px solid var(--ws-line); border-radius: 6px;
  padding: 2px 8px; width: 120px; outline: none;
}
.ws-admin-limit-input:focus { border-color: var(--ws-ink-3); }
.ws-admin-limit-input-err { border-color: var(--ws-err); }
.ws-admin-limit-mo {
  font-size: 13px; color: var(--ws-ink-4); margin-left: 2px;
}
.ws-admin-limit-sub { font-size: 11.5px; color: var(--ws-ink-4); margin-top: 4px; }
.ws-admin-limit-err {
  margin-top: 6px; font-size: 11.5px; font-weight: 500;
  color: var(--ws-err); line-height: 1.4;
}

@media (max-width: 1100px) {
  .ws-admin-grid-2 { grid-template-columns: 1fr; }
  .ws-admin-kpis { grid-template-columns: repeat(2, 1fr); }
  .ws-admin-limits-grid { grid-template-columns: 1fr; }
  .ws-admin-hero { grid-template-columns: 1fr; }
}

/* ===== Context library (agent context tab) ===== */
.ws-ctx-dropzone {
  border: 1.5px dashed var(--ws-line-2);
  border-radius: var(--ws-r-lg);
  padding: 28px;
  text-align: center;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
  transition: all 0.18s;
  cursor: pointer;
  margin-bottom: 16px;
}
.ws-ctx-dropzone:hover, .ws-ctx-dropzone.over {
  border-color: var(--ws-ink-3);
  background: var(--ws-hover);
  color: var(--ws-ink-2);
}
.ws-ctx-dz-icon {
  width: 40px; height: 40px; margin: 0 auto 10px;
  border-radius: 10px; background: white;
  border: 1px solid var(--ws-line);
  display: grid; place-items: center;
  color: var(--ws-ink-3);
}
.ws-ctx-dz-title {
  font-family: var(--ws-serif);
  font-size: 17px; color: var(--ws-ink);
  margin-bottom: 4px; font-weight: 600;
}
.ws-ctx-dz-sub { font-size: 12.5px; color: var(--ws-ink-4); }
.ws-ctx-dz-types {
  display: flex; gap: 5px; justify-content: center; margin-top: 12px; flex-wrap: wrap;
}
.ws-ctx-dz-btn {
  display: inline-flex; align-items: center; gap: 5px;
  border: 1px solid var(--ws-line);
  background: var(--ws-panel);
  color: var(--ws-ink-2);
  cursor: pointer;
  font-family: var(--ws-sans);
}
.ws-ctx-dz-btn:hover { background: var(--ws-hover); }

.ws-ctx-composer {
  display: flex; flex-direction: column; gap: 8px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 14px;
  margin-bottom: 16px;
}
.ws-ctx-composer-actions {
  display: flex; justify-content: flex-end; gap: 6px;
}
.ws-ctx-composer-hint {
  font-size: 11.5px; color: var(--ws-ink-4); line-height: 1.4;
}

.ws-ctx-meter {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  margin: 0 0 14px;
}
.ws-ctx-meter-label {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4);
}
.ws-ctx-meter-bar {
  flex: 1; height: 6px;
  background: white; border-radius: 999px; overflow: hidden;
  border: 1px solid var(--ws-line);
}
.ws-ctx-meter-fill { height: 100%; background: var(--ws-ink); border-radius: 999px; }
.ws-ctx-meter-text {
  font-size: 12px; color: var(--ws-ink-3);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}

.ws-ctx-list { display: flex; flex-direction: column; gap: 6px; }
.ws-ctx-item {
  display: grid;
  grid-template-columns: 36px 1fr auto auto auto;
  gap: 12px;
  align-items: center;
  padding: 10px 14px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
}
.ws-ctx-item:hover { background: var(--ws-soft); }
.ws-ctx-item--editing {
  grid-template-columns: 36px 1fr;
  align-items: flex-start;
}
.ws-ctx-edit-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.ws-ctx-thumb {
  width: 36px; height: 36px; border-radius: 7px;
  display: grid; place-items: center;
  font-family: var(--ws-mono); font-size: 10px; font-weight: 700;
  letter-spacing: 0.04em;
  color: white;
}
.ws-ctx-thumb.pdf { background: var(--ws-err); }
.ws-ctx-thumb.xlsx { background: var(--ws-ok); }
.ws-ctx-thumb.image { background: var(--ws-a-postmeeting); }
.ws-ctx-thumb.link { background: var(--ws-info); }
.ws-ctx-thumb.text { background: var(--ws-ink-3); }
.ws-ctx-thumb.note { background: var(--ws-ink); }
.ws-ctx-name { font-size: 13.5px; font-weight: 500; color: var(--ws-ink); }
.ws-ctx-meta { font-size: 11.5px; color: var(--ws-ink-4); margin-top: 1px; }

.ws-ctx-actions { display: inline-flex; gap: 4px; }
.ws-btn-icon {
  width: 26px; height: 26px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--ws-ink-3);
  cursor: pointer;
  display: inline-grid; place-items: center;
}
.ws-btn-icon:hover {
  background: var(--ws-hover);
  border-color: var(--ws-line);
  color: var(--ws-ink);
}

.ws-pill.ws-pill-err {
  background: rgba(184, 74, 62, 0.08);
  color: var(--ws-err);
  border: 1px solid rgba(184, 74, 62, 0.25);
  cursor: pointer;
}

.ws-ctx-privacy {
  margin-top: 14px;
  padding: 12px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  font-size: 12.5px; color: var(--ws-ink-3);
  display: flex; gap: 10px; align-items: flex-start;
}
.ws-ctx-privacy strong { color: var(--ws-ink-2); }

/* ===== Home composer (task creation) ===== */
.ws-home-composer {
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
}

/* Continue-last link above the new chat composer */
.ws-chat-continue-bar {
  display: flex;
  justify-content: flex-start;
  padding: 0 0 6px;
}

/* Analytics view */
.ws-tq-analytics { display: flex; flex-direction: column; gap: 16px; }
.ws-tq-stat-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.ws-tq-stat {
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); padding: 16px 18px;
}
.ws-tq-stat-k {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
}
.ws-tq-stat-v {
  margin-top: 6px; font-size: 32px; font-weight: 600; color: var(--ws-ink);
  font-variant-numeric: tabular-nums; line-height: 1; letter-spacing: -0.02em;
}
.ws-tq-unit { font-size: 18px; color: var(--ws-ink-3); font-weight: 500; margin-left: 2px; }
.ws-tq-stat-trend { margin-top: 8px; font-size: 11.5px; color: var(--ws-ink-3); }

/* Bar chart card */
.ws-tq-chart-card {
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); padding: 18px 20px;
}
.ws-tq-chart-head {
  display: flex; justify-content: space-between; align-items: flex-start;
  margin-bottom: 18px;
}
.ws-tq-chart-title { font-size: 14px; font-weight: 600; color: var(--ws-ink); }
.ws-tq-chart-sub { font-size: 11.5px; color: var(--ws-ink-3); margin-top: 2px; }
.ws-tq-chart-legend { display: flex; gap: 12px; font-size: 11px; color: var(--ws-ink-3); }
.ws-tq-chart-legend span { display: inline-flex; align-items: center; gap: 5px; }
.ws-tq-leg {
  width: 8px; height: 8px; border-radius: 2px; display: inline-block; font-style: normal;
}
.ws-tq-leg.done { background: var(--ws-ink); }
.ws-tq-leg.failed { background: #C9462C; }
.ws-tq-bars {
  display: flex; align-items: flex-end; gap: 8px;
  height: 110px; padding-bottom: 24px; position: relative;
}
.ws-tq-bar-wrap {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 6px;
  height: 100%; position: relative;
}
.ws-tq-bar-stack {
  display: flex; flex-direction: column-reverse;
  width: 100%; max-width: 32px; height: 100%;
  justify-content: flex-start; align-items: center; gap: 1px;
}
.ws-tq-bar {
  width: 100%; background: var(--ws-ink); border-radius: 3px 3px 0 0;
  transition: opacity 150ms;
}
.ws-tq-bar.fail { background: #C9462C; }
.ws-tq-bar-wrap:hover .ws-tq-bar { opacity: 0.75; }
.ws-tq-bar-label {
  position: absolute; bottom: 0;
  font-size: 10px; color: var(--ws-ink-4); font-variant-numeric: tabular-nums;
}

/* Agent breakdown */
.ws-tq-agent-breakdown {
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); padding: 18px 20px;
}
.ws-tq-agent-row {
  display: grid; grid-template-columns: 22px 140px 1fr 50px 110px;
  gap: 12px; align-items: center; padding: 8px 0; font-size: 13px;
}
.ws-tq-agent-row + .ws-tq-agent-row { border-top: 1px solid var(--ws-line); }
.ws-tq-agent-sw {
  width: 22px; height: 22px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 700; color: white;
}
.ws-tq-agent-nm { color: var(--ws-ink); font-weight: 500; }
.ws-tq-agent-bar {
  height: 6px; background: var(--ws-soft); border-radius: 3px; overflow: hidden;
}
.ws-tq-agent-bar > span {
  display: block; height: 100%; border-radius: 3px; transition: width 0.2s;
}
.ws-tq-agent-count {
  text-align: right; font-variant-numeric: tabular-nums;
  font-size: 12px; color: var(--ws-ink-2);
}
.ws-tq-agent-cost {
  text-align: right; font-variant-numeric: tabular-nums;
  font-size: 12px; color: var(--ws-ink-4);
}

/* ===== Usage page ===== */
.ws-usage-hero {
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); padding: 20px 22px;
}
.ws-usage-hero.warn { border-color: var(--ws-warn); background: #FEF6EE; }
.ws-usage-hero.err { border-color: var(--ws-err); background: #FEF2F0; }
.ws-usage-hero-top {
  display: flex; justify-content: space-between; align-items: flex-start;
}
.ws-usage-hero-label {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
}
.ws-usage-hero-value {
  margin-top: 6px; font-size: 32px; font-weight: 600; color: var(--ws-ink);
  font-variant-numeric: tabular-nums; line-height: 1; letter-spacing: -0.02em;
}
.ws-usage-hero-of {
  font-size: 14px; font-weight: 400; color: var(--ws-ink-4); margin-left: 4px;
}
.ws-usage-hero-badge {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 10px; border-radius: 6px;
  font-size: 12px; font-weight: 600;
}
.ws-usage-hero-badge.warn { background: #FEF0D5; color: var(--ws-warn); }
.ws-usage-hero-badge.err { background: #FDDDD8; color: var(--ws-err); }
.ws-usage-hero-bar {
  margin-top: 14px; height: 6px;
  background: var(--ws-line); border-radius: 999px; overflow: hidden;
}
.ws-usage-hero-bar-fill {
  height: 100%; border-radius: 999px; transition: width 0.3s;
}
.ws-usage-hero-bar-fill.ok { background: var(--ws-ink); }
.ws-usage-hero-bar-fill.warn { background: var(--ws-warn); }
.ws-usage-hero-bar-fill.err { background: var(--ws-err); }
.ws-usage-hero-meta {
  margin-top: 6px; font-size: 12px; color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
}
.ws-usage-hero-pool-aside {
  text-align: right; font-variant-numeric: tabular-nums;
}
.ws-usage-hero-pool-aside-k {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
}
.ws-usage-hero-pool-aside-v {
  margin-top: 6px; font-size: 14px; color: var(--ws-ink-2);
}

.ws-usage-dominant-banner {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 12px 14px; border-radius: var(--ws-r-md);
  background: #FEF6EE; border: 1px solid var(--ws-warn);
  color: var(--ws-warn);
}
.ws-usage-dominant-title {
  font-size: 13px; font-weight: 600; line-height: 1.3;
}
.ws-usage-dominant-body {
  margin-top: 2px; font-size: 12px; color: var(--ws-ink-2); line-height: 1.45;
}

.ws-usage-agent-row { cursor: pointer; }
.ws-usage-agent-row:hover { background: rgba(0,0,0,0.02); }
.ws-usage-agent-row.paused .ws-tq-agent-nm { color: var(--ws-err); }
.ws-usage-paused-pill {
  display: inline-block; margin-left: 6px;
  padding: 1px 6px; border-radius: 4px;
  font-size: 10px; font-weight: 600;
  background: #FDDDD8; color: var(--ws-err);
}
.ws-usage-budget-bar-wrap {
  display: flex; align-items: center; gap: 6px; flex: 1; min-width: 0;
}
.ws-usage-budget-bar-wrap .ws-tq-agent-bar { flex: 1; }
.ws-usage-budget-pct {
  font-size: 11px; font-variant-numeric: tabular-nums;
  color: var(--ws-ink-4); flex-shrink: 0; width: 32px; text-align: right;
}
.ws-usage-budget-pct.warn { color: var(--ws-warn); font-weight: 600; }
.ws-usage-budget-pct.err { color: var(--ws-err); font-weight: 600; }
.ws-usage-budget-label {
  color: var(--ws-ink-5); font-size: 11px;
}

/* Sidebar: paused agent dot */
.ws-sb-agent-status {
  width: 6px; height: 6px; border-radius: 50%;
  flex-shrink: 0; margin-left: auto;
}
.ws-sb-agent-status.paused { background: var(--ws-err); }

/* Sidebar: Usage item warning */
.ws-sb-item .ws-count.warn {
  background: #FDDDD8; color: var(--ws-err);
}

/* Agent page: budget card */
.ws-agent-reset-box {
  margin-top: 24px; padding: 14px 16px;
  border: 1px solid var(--ws-line); border-radius: var(--ws-r-md);
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
}
.ws-agent-reset-info {
  display: flex; gap: 10px; color: var(--ws-ink-4);
}
.ws-agent-reset-title {
  font-size: 13px; font-weight: 600; color: var(--ws-ink);
}
.ws-agent-reset-desc {
  font-size: 12px; color: var(--ws-ink-4); margin-top: 2px; line-height: 1.4;
}

/* ===== Legacy overlay close bar ===== */
.ws-overlay-close-bar {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding: 6px 32px;
  border-bottom: 1px solid var(--ws-line);
  background: var(--ws-bg);
}
.ws-overlay-close {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-family: var(--ws-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--ws-ink-3);
  background: none;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
}
.ws-overlay-close:hover {
  color: var(--ws-ink);
  border-color: var(--ws-line-2);
}

.ws-template-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(123, 97, 255, 0.12);
  color: #5b3df0;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
}
.ws-template-badge--off {
  background: rgba(107, 114, 128, 0.12);
  color: #6b7280;
}
.ws-template-badge__off-suffix {
  opacity: 0.8;
}
.ws-template-badge--compact {
  padding: 0;
  width: 18px;
  height: 18px;
  justify-content: center;
  gap: 0;
}

.ws-hire-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ws-hire-row {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  background: var(--ws-panel);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
}
.ws-hire-row:hover {
  border-color: var(--ws-line-2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}
.ws-hire-row-clickable .ws-hire-row-main {
  cursor: pointer;
}
.ws-hire-row-main {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 14px;
}
.ws-hire-row-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(123, 97, 255, 0.10);
  color: #5b3df0;
  overflow: hidden;
}
.ws-hire-row-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ws-hire-row-body {
  min-width: 0;
}
.ws-hire-row-title-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ws-hire-row-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--ws-ink);
}
.ws-hire-row-pill {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
}
.ws-hire-row-pill-new {
  background: rgba(47, 122, 78, 0.12);
  color: var(--ws-ok);
}
.ws-hire-row-role {
  font-size: 12.5px;
  color: var(--ws-ink-3);
  margin-top: 2px;
}
.ws-hire-row-mission {
  font-size: 12.5px;
  color: var(--ws-ink-4);
  margin-top: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
}

.ws-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  display: grid;
  place-items: center;
  z-index: 1000;
}
.ws-modal {
  background: var(--ws-panel);
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  width: 440px;
  max-width: calc(100vw - 32px);
  overflow: hidden;
}
.ws-modal-head {
  padding: 16px 20px 8px;
}
.ws-modal-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ws-ink);
}
.ws-modal-body {
  padding: 4px 20px 16px;
  font-size: 13px;
  color: var(--ws-ink-3);
  line-height: 1.55;
}
.ws-modal-body p {
  margin: 0;
}
.ws-modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  background: var(--ws-soft);
  border-top: 1px solid var(--ws-line);
}
.ws-btn-primary {
  background: var(--ws-ink);
  color: #fff;
  border-color: transparent;
}
.ws-btn-primary:hover {
  background: var(--ws-ink-2);
}
.ws-btn-danger {
  background: #b84a3e;
  color: #fff;
  border-color: transparent;
}
.ws-btn-danger:hover {
  filter: brightness(1.05);
}

.ws-skill-group-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ws-ink-4);
  padding: 14px 4px 8px 4px;
}
.ws-skill-group-head::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--ws-ink-5);
  flex-shrink: 0;
}
.ws-skill-group-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: rgba(29, 61, 72, 0.08);
  font-size: 10.5px;
  font-weight: 500;
  color: var(--ws-accent);
  text-transform: none;
  letter-spacing: 0;
}

/* Premium card treatment for the Skills tab — warm off-white that lifts off
   the page bg without the visual noise of a coloured top stripe. */
.ws-skills-card {
  background: linear-gradient(180deg, #fbfcfd 0%, #ffffff 80px, #ffffff 100%);
  border: 1px solid var(--ws-line);
  border-radius: 12px;
  padding: 22px 22px 20px;
  /* Top gap now comes from .ws-settings-body so every settings tab matches. */
  margin: 0 0 18px;
  box-shadow: 0 1px 2px rgba(20, 36, 50, 0.03);
}
/* Skill row title + pills: line up vertically, breathe horizontally */
.ws-skills-card .ws-auto-label {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ws-skills-card .ws-admin-card-head {
  margin-bottom: 4px;
}
.ws-skills-card .ws-admin-card-head h3 {
  font-family: var(--ws-serif);
  font-weight: 600;
  font-size: 19px;
  letter-spacing: -0.01em;
  color: var(--ws-accent);
}
.ws-skills-card .ws-sub {
  font-size: 12.5px;
  color: var(--ws-ink-4);
  display: block;
  margin-top: 4px;
}

/* Active-count chip in the card head — small and quiet */
.ws-skill-active-chip {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(29, 61, 72, 0.08);
  color: var(--ws-accent);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0;
  font-family: var(--ws-sans);
  text-transform: none;
  line-height: 1;
}

/* Per-scope icon chips — keeps each row visually anchored to its origin */
.ws-auto-icon-skill-user {
  background: rgba(74, 107, 133, 0.10);
  color: var(--ws-a-forecasting);
}
.ws-auto-icon-skill-customer {
  background: rgba(184, 147, 90, 0.14);
  color: var(--ws-a-human);
}
.ws-auto-icon-skill-upsales {
  background: rgba(29, 61, 72, 0.12);
  color: var(--ws-accent);
}

/* Per-scope pill colours — refined and editorial, not Bootstrap-loud.
   Sized down to sit comfortably next to a row title without competing. */
.ws-skills-card .ws-pill {
  font-size: 9.5px;
  padding: 1px 6px;
  height: 16px;
  letter-spacing: 0.04em;
}
.ws-pill-scope-user {
  background: rgba(74, 107, 133, 0.10);
  color: var(--ws-a-forecasting);
  border-color: rgba(74, 107, 133, 0.22);
}
.ws-pill-scope-customer {
  background: rgba(184, 147, 90, 0.14);
  color: var(--ws-a-human);
  border-color: rgba(184, 147, 90, 0.28);
}
.ws-pill-scope-upsales {
  background: var(--ws-accent);
  color: #e8f9f8;
  border-color: var(--ws-accent);
}

/* Skill rows: subtle hover and a faint per-scope tint when expanded */
.ws-skills-card .ws-auto-row {
  background: #ffffff;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.ws-skills-card .ws-auto-row:hover {
  background: #fbfcfd;
  border-color: var(--ws-line-2);
}
.ws-skills-card .ws-auto-row-expanded {
  box-shadow: 0 2px 8px rgba(20, 36, 50, 0.04);
}

/* Editable fields inside an expanded skill (edit, create, import): stronger
   border + faint inset so they read clearly against the white card. The
   default ws-agent-edit-input was tuned for the dark Workspace surface and
   disappears on white. */
.ws-skills-card .ws-skill-expanded {
  background: #f7f9fb;
  border-radius: 0 0 var(--ws-r-md) var(--ws-r-md);
}
.ws-skills-card .ws-skill-expanded label > span,
.ws-skills-card .ws-auto-row-expanded label > span {
  font-weight: 500;
  color: var(--ws-ink-3);
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input,
.ws-skills-card .ws-auto-row-expanded select.ws-agent-edit-input,
.ws-skills-card .ws-auto-row-expanded textarea {
  background: #ffffff;
  border: 1px solid var(--ws-line-2);
  box-shadow: inset 0 1px 0 rgba(20, 36, 50, 0.02);
  color: var(--ws-ink);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input:focus,
.ws-skills-card .ws-auto-row-expanded select.ws-agent-edit-input:focus,
.ws-skills-card .ws-auto-row-expanded textarea:focus {
  outline: none;
  border-color: var(--ws-a-forecasting);
  box-shadow: 0 0 0 3px rgba(74, 107, 133, 0.12);
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input:disabled,
.ws-skills-card .ws-auto-row-expanded textarea:disabled {
  background: #f1f3f6;
  color: var(--ws-ink-3);
}

.ws-pages-row-delete {
  display: inline-flex;
  align-items: center;
  padding: 6px;
  border: 0;
  border-radius: var(--ws-r-sm);
  background: transparent;
  color: var(--ws-ink-5);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: color 220ms ease, background-color 220ms ease, padding 220ms ease;
}
.ws-pages-row-delete:hover {
  color: var(--ws-err);
}
.ws-pages-row-delete:disabled {
  cursor: wait;
}
.ws-pages-row-delete-confirm,
.ws-pages-row-delete-confirm:hover {
  color: #ffffff;
  background: var(--ws-err);
  padding: 6px 10px 6px 8px;
}
.ws-pages-row-delete-label {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  max-width: 0;
  margin-left: 0;
  opacity: 0;
  transform: translateX(-4px);
  transition: max-width 260ms ease, margin-left 260ms ease, opacity 200ms ease 60ms, transform 260ms ease;
}
.ws-pages-row-delete-confirm .ws-pages-row-delete-label {
  max-width: 240px;
  margin-left: 6px;
  opacity: 1;
  transform: translateX(0);
}

/* AI provider (BYOK) form inputs */
.ws-prov-input {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 10px;
  border: 1px solid var(--ws-line-2);
  border-radius: var(--ws-r-sm);
  background: #fff;
  font-family: var(--ws-sans);
  font-size: 13px;
  color: var(--ws-ink);
  transition: border-color 0.12s, box-shadow 0.12s;
}
.ws-prov-input::placeholder { color: var(--ws-ink-5); }
.ws-prov-input:focus { outline: none; border-color: var(--ws-accent); box-shadow: 0 0 0 3px var(--pr-accent-soft-2); }

/* ===== Delegation drawer (embedded chat in a narrow Sheet) ===== */
/* No horizontal scrollbar in the drawer — the chat scroller's inline
   overflow:auto otherwise shows a spurious x-bar from sub-pixel/decorative
   overflow. Content adapts to the width instead (tables reflow below). */
.ws-embedded-drawer .ws-chat-body > div { overflow-x: hidden !important; }
/* Tables: fit the drawer width and wrap cell content instead of scrolling
   horizontally (overrides the main chat's display:block; overflow-x:auto). */
.ws-embedded-drawer .pr-prose table { display: table; width: 100%; overflow-x: hidden; }
.ws-embedded-drawer .pr-prose th,
.ws-embedded-drawer .pr-prose td { white-space: normal; overflow-wrap: anywhere; }
`;

export default workspaceStyles;
